//#region src/lib/action-types.ts
var e = /* @__PURE__ */ function(e) {
	return e.updateRegions = "updateRegions", e.updatePaths = "updatePaths", e.updateLineParkings = "updateLineParkings", e.addSite = "addSite", e.deleteSite = "deleteSite", e.updateSiteBoundary = "updateSiteBoundary", e.updateSiteOffset = "updateSiteOffset", e.updateSiteSetback = "updateSiteSetback", e.updateSiteBuildableAreas = "updateSiteBuildableAreas", e.cutSite = "cutSite", e.unionSites = "unionSites", e.lockSite = "lockSite", e.putBuilding = "putBuilding", e.updateUnitMix = "updateUnitMix", e.updateUnitMixOn = "updateUnitMixOn", e.updateWingLengthRange = "updateWingLengthRange", e.updateWingMinSetback = "updateWingMinSetback", e.updateWingSetbackFactor = "updateWingSetbackFactor", e.updateBalconiesAffectMassing = "updateBalconiesAffectMassing", e.updateCorridorEndApartments = "updateCorridorEndApartments", e.updateShiftedCorners = "updateShiftedCorners", e.updateFragmentGapFillMethod = "updateFragmentGapFillMethod", e.updateResizeCornerCores = "updateResizeCornerCores", e.updateAvoidNorthFactor = "updateAvoidNorthFactor", e.updateCorridorWidth = "updateCorridorWidth", e.updateUnitHeight = "updateUnitHeight", e.updateUnitDepth = "updateUnitDepth", e.updateMaxLevels = "updateMaxLevels", e.updateCommercialHeight = "updateCommercialHeight", e.updateFacadeWallThickness = "updateFacadeWallThickness", e.updatePartitionWallThickness = "updatePartitionWallThickness", e.updateStructuralFloorThickness = "updateStructuralFloorThickness", e.updateFinishingFloorThickness = "updateFinishingFloorThickness", e.updateRoofThickness = "updateRoofThickness", e.updateMaxFragmentLength = "updateMaxFragmentLength", e.updateMaxCornerFragmentLength = "updateMaxCornerFragmentLength", e.updateMaxGsi = "updateMaxGsi", e.updateMaxAncillaryGsi = "updateMaxAncillaryGsi", e.updateTargetFar = "updateTargetFar", e.updateParkingMultiplier = "updateParkingMultiplier", e.updateParkingFactors = "updateParkingFactors", e.updateLoadType = "updateLoadType", e.setApartmentSet = "setApartmentSet", e.addVariant = "addVariant", e.duplicateLayout = "duplicateLayout", e.renameLayout = "renameLayout", e.removeLayout = "removeLayout", e.restoreLayout = "restoreLayout", e.selectLayout = "selectLayout", e.selectVariant = "selectVariant", e.unselectVariant = "unselectVariant", e.updateBuildingMaxLevels = "updateBuildingMaxLevels", e.updateUnderlay = "updateUnderlay", e.removeUnderlay = "removeUnderlay", e.restoreUnderlay = "restoreUnderlay", e;
}({}), t = {
	availableUnits: [],
	coreTemplate: void 0,
	cornerUnits: [],
	cornerCoreTemplate: void 0,
	coreSide: "both",
	unitMix: {},
	fillFactor: 1,
	unitMixFactor: .5,
	corePositionFactor: .25,
	dualAspectFactor: .25,
	maxFragmentLength: 40,
	maxCornerFragmentLength: void 0,
	corridorEndApartments: !0,
	roofThickness: .5,
	roofVGap: .01
}, n = {
	maxLevels: {
		min: 1,
		max: 30
	},
	commercialHeight: {
		min: 2.5,
		max: 6
	},
	corridorWidth: {
		min: 1.125,
		max: 3.75
	},
	unitHeight: {
		min: 2.5,
		max: 4.5
	},
	unitDepth: {
		min: 4,
		max: 14
	},
	wingLength: {
		min: 12.95,
		max: 150
	},
	maxFragmentLength: {
		min: 1,
		max: t.maxFragmentLength
	},
	maxCornerFragmentLength: {
		min: 1,
		max: t.maxFragmentLength
	},
	wingMinSetback: {
		min: 0,
		max: 20
	},
	wingSetbackFactor: {
		min: 0,
		max: 2
	},
	avoidNorthFactor: {
		min: 0,
		max: 1
	},
	maxGsi: {
		min: 0,
		max: 1
	},
	maxAncillaryGsi: {
		min: 0,
		max: 1
	},
	targetFar: {
		min: 0,
		max: 10
	},
	parkingMultiplier: {
		min: 0,
		max: 2
	},
	parkingSpaces: {
		min: 0,
		max: 2
	},
	parkingApartmentArea: {
		min: 0,
		max: 999
	},
	parkingAreaBasis: {
		min: 1,
		max: 200
	},
	thickness: {
		min: 0,
		max: 2
	}
};
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/util.js
function r(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function i(e, t = "|") {
	return e.map((e) => le(e)).join(t);
}
function a(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
var o = class {
	constructor(e) {
		this._getter = e, this._value = void 0;
	}
	get value() {
		let e = this._getter;
		return e !== void 0 && (this._value = e(), this._getter = void 0), this._value;
	}
};
function s(e) {
	return new o(e);
}
function c(e) {
	return e == null;
}
function l(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function u(e, t) {
	let n = e / t, r = Math.round(n), i = 4 * 2 ** -52 * Math.max(Math.abs(n), 1);
	return Math.abs(n - r) < i ? 0 : n - r;
}
function d(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function f(e) {
	let t = Object.getOwnPropertyDescriptor(e, "shape");
	return t?.get ? t.get.raw : t?.value;
}
function p(e) {
	return f(e._zod.def) ?? e._zod.def.shape;
}
function m(e, t, n) {
	Object.defineProperty(e, t, {
		get() {
			let e = n();
			return d(this, t, e), e;
		},
		enumerable: !0,
		configurable: !0
	});
}
function h(e, t, n) {
	t in e ? d(e, t, n) : e[t] = n;
}
function g(e, t, n, r) {
	let i = p(t);
	for (let a of n) {
		let n = Object.getOwnPropertyDescriptor(i, a);
		n.enumerable && (n.get ? m(e, a, () => {
			let e = t._zod.def.shape[a];
			return r ? r(e, a) : e;
		}) : h(e, a, r ? r(n.value, a) : n.value));
	}
}
function ee(e, t) {
	for (let n of Reflect.ownKeys(t)) {
		let r = Object.getOwnPropertyDescriptor(t, n);
		r.enumerable && (r.get ? m(e, n, () => t[n]) : h(e, n, r.value));
	}
}
function _(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function te(e) {
	return JSON.stringify(e);
}
function ne(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var re = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function ie(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var ae = /* @__PURE__*/ s(() => {
	if (A.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function v(e) {
	if (ie(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return ie(n) !== !1 && Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") !== !1;
}
function oe(e) {
	return v(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
var se = /* @__PURE__*/ new Set([
	"string",
	"number",
	"symbol"
]);
function ce(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function y(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function b(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function le(e) {
	return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function ue(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin !== void 0 && e[t]._zod.optout === "optional");
}
var de = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, fe = {
	int64: [/* @__PURE__*/ BigInt("-9223372036854775808"), /* @__PURE__*/ BigInt("9223372036854775807")],
	uint64: [/* @__PURE__*/ BigInt(0), /* @__PURE__*/ BigInt("18446744073709551615")]
};
function pe(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	let i = {};
	return g(i, e, me(e, t)), y(e, _(n, {
		shape: i,
		checks: []
	}));
}
function me(e, t) {
	let n = p(e), r = [];
	for (let e of Reflect.ownKeys(t)) {
		if (!Object.getOwnPropertyDescriptor(n, e)?.enumerable) throw Error(`Unrecognized key: "${String(e)}"`);
		t[e] && r.push(e);
	}
	return r;
}
function he(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	let i = new Set(me(e, t)), a = {};
	return g(a, e, Reflect.ownKeys(p(e)).filter((e) => !i.has(e))), y(e, _(n, {
		shape: a,
		checks: []
	}));
}
function ge(e, t) {
	if (!v(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = p(e);
		for (let e of Reflect.ownKeys(t)) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return y(e, _(e._zod.def, { shape: _e(e, t) }));
}
function _e(e, t) {
	let n = {};
	return g(n, e, Reflect.ownKeys(p(e))), ee(n, t), n;
}
function ve(e, t) {
	if (!v(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return y(e, _(e._zod.def, { shape: _e(e, t) }));
}
function ye(e, t) {
	if (!t?._zod?.def) throw Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
	if (e._zod.def.checks?.length) throw Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
	let n = {};
	return g(n, e, Reflect.ownKeys(p(e))), g(n, t, Reflect.ownKeys(p(t))), y(e, _(e._zod.def, {
		shape: n,
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: t._zod.def.checks ?? []
	}));
}
function be(e, t, n, r = "partial") {
	let i = t._zod.def.checks;
	if (i && i.length > 0) throw Error(`.${r}() cannot be used on object schemas containing refinements`);
	let a = n ? new Set(me(t, n)) : void 0, o = {};
	return g(o, t, Reflect.ownKeys(p(t)), e && ((t, n) => a && !a.has(n) ? t : new e({
		type: "optional",
		innerType: t
	}))), y(t, _(t._zod.def, {
		shape: o,
		checks: []
	}));
}
function xe(e, t, n) {
	let r = n ? new Set(me(t, n)) : void 0, i = {};
	return g(i, t, Reflect.ownKeys(p(t)), (t, n) => r && !r.has(n) ? t : new e({
		type: "nonoptional",
		innerType: t
	})), y(t, _(t._zod.def, { shape: i }));
}
function x(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function Se(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue === !1) return !0;
	return !1;
}
function Ce(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function S(e) {
	return typeof e == "string" ? e : e?.message;
}
function we(e, t, n) {
	var r;
	for (let i = t; i < e.length; i++) (r = e[i]).schema ?? (r.schema = n);
}
function C(e, t, n) {
	var r;
	let i = e.inst?._zod?.traits;
	i?.has("$ZodType") && (i.has("$ZodCheck") ? (r = e).schema ?? (r.schema = e.inst) : e.schema = e.inst);
	let a = e.schema === e.inst ? void 0 : e.schema?._zod.def?.error, o = e.message ? e.message : S(e.inst?._zod.def?.error?.(e)) ?? S(a?.(e)) ?? S(t?.error?.(e)) ?? S(n.customError?.(e)) ?? S(n.localeError?.(e)) ?? "Invalid input", s = {};
	for (let t of Object.keys(e)) t !== "inst" && t !== "schema" && t !== "continue" && t !== "input" && t !== "__proto__" && (s[t] = e[t]);
	return s.path ??= [], s.message = o, t?.reportInput && (s.input = e.input), s;
}
var Te = /[\uD800-\uDBFF]/;
function Ee(e) {
	let t = e.length;
	if (!Te.test(e)) return t;
	let n = t;
	for (let r = 0; r < t - 1; r++) (e.charCodeAt(r) & 64512) == 55296 && (e.charCodeAt(r + 1) & 64512) == 56320 && (n--, r++);
	return n;
}
function De(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Oe(e) {
	let t = typeof e;
	switch (t) {
		case "number": return Number.isNaN(e) ? "nan" : "number";
		case "object": {
			if (e === null) return "null";
			if (Array.isArray(e)) return "array";
			let t = e;
			if (t && Object.getPrototypeOf(t) !== Object.prototype && "constructor" in t && t.constructor) return t.constructor.name;
		}
	}
	return t;
}
function w(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
function ke(e, t) {
	for (let n in t) {
		let r = Object.getOwnPropertyDescriptor(t, n);
		r.get ? Object.defineProperty(e, n, {
			...r,
			enumerable: !1
		}) : Me(e, n, r.value);
	}
}
function T(e, t, n, r = !0) {
	return Object.defineProperty(e, t, {
		configurable: !0,
		writable: !0,
		enumerable: r,
		value: n
	}), n;
}
function Ae(e, t, n) {
	return T(e, t, n, !1);
}
function je(e, t) {
	for (let n in e) {
		let r = e[n];
		Object.defineProperty(t, n, {
			configurable: !0,
			enumerable: !0,
			get() {
				return T(this, n, r(this));
			},
			set(e) {
				T(this, n, e);
			}
		});
	}
	return t;
}
function Me(e, t, n) {
	Object.defineProperty(e, t, {
		configurable: !0,
		get() {
			return this == null ? n : T(this, t, n.bind(this));
		},
		set(e) {
			T(this, t, e);
		}
	});
}
function Ne(e, t) {
	let n = Object.getPrototypeOf(e);
	return t in n ? void 0 : n;
}
var Pe, E = !1, Fe = {
	configurable: !0,
	get() {
		E = !0;
	}
};
function D(e, t, n) {
	let r = Object.getPrototypeOf(e._zod);
	if (t in r && Pe !== e._zod) {
		Pe = void 0;
		return;
	}
	Pe = e._zod, Object.defineProperty(r, t, {
		configurable: !0,
		get() {
			Object.defineProperty(this, t, Fe);
			let e = E;
			E = !1;
			try {
				let r = n(this);
				return E ? delete this[t] : Object.defineProperty(this, t, {
					configurable: !0,
					writable: !0,
					value: r
				}), E ||= e, r;
			} catch (n) {
				throw delete this[t], E ||= e, n;
			}
		},
		set(e) {
			Object.defineProperty(this, t, {
				configurable: !0,
				writable: !0,
				value: e
			});
		}
	});
}
function Ie(e, t, n, r) {
	let i = Ne(e, t);
	i && Object.defineProperty(i, t, {
		configurable: !0,
		get() {
			let e = {
				configurable: !0,
				writable: !0,
				enumerable: r,
				value: void 0
			};
			return Object.defineProperty(this, t, e), e.value = n(this), Object.defineProperty(this, t, e), e.value;
		},
		set(e) {
			Object.defineProperty(this, t, {
				configurable: !0,
				writable: !0,
				enumerable: r,
				value: e
			});
		}
	});
}
var Le = "~constantCatch";
function Re(e) {
	let t = () => e;
	return t[Le] = !0, t;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/core.js
var ze, Be = {
	value: void 0,
	enumerable: !1
}, Ve = "captureStackTrace" in Error ? Error : null;
function He(e) {
	let t = Ve;
	if (t) {
		let n = t.stackTraceLimit;
		if (typeof n == "number") {
			try {
				t.stackTraceLimit = 0;
			} catch {
				return Ve = null, new e();
			}
			try {
				return new e();
			} finally {
				t.stackTraceLimit = n;
			}
		}
	}
	return new e();
}
function O(e, t, n, r) {
	let i = {};
	function a(e) {
		this.def = e, this.constr = d, this.traits = /* @__PURE__ */ new Set();
	}
	a.prototype = i;
	let o = n, s = o && /* @__PURE__ */ new WeakSet();
	function c(n, r) {
		if (!n._zod) {
			Be.value = new a(r);
			try {
				Object.defineProperty(n, "_zod", Be);
			} finally {
				Be.value = void 0;
			}
		} else if (n._zod.traits.has(e)) return;
		if (n._zod.traits.add(e), t(n, r), s) {
			let e = Object.getPrototypeOf(n), t = n._zod.constr.prototype, r = e;
			for (; r && r !== t;) r = Object.getPrototypeOf(r);
			let i = r ?? e;
			s.has(i) || (s.add(i), ke(i, o));
		}
		let i = d.prototype;
		for (let e in i) Object.prototype.hasOwnProperty.call(i, e) && (e in n || (n[e] = i[e].bind(n)));
	}
	let l = r?.Parent ?? Object;
	class u extends l {}
	Object.defineProperty(u, "name", { value: e });
	function d(e) {
		let t = r?.Parent ? He(u) : this;
		c(t, e);
		let n = t._zod.deferred;
		if (n) {
			for (let e of n) e();
			t._zod.deferred = void 0;
		}
		let i = globalThis.__zod_globalConfig?.postProcessor;
		return i && i(t), t;
	}
	return Object.defineProperty(d, "init", { value: c }), Object.defineProperty(d, Symbol.hasInstance, { value: (t) => r?.Parent && t instanceof r.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(d, "name", { value: e }), d;
}
var k = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, Ue = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
};
(ze = globalThis).__zod_globalConfig ?? (ze.__zod_globalConfig = {});
var A = globalThis.__zod_globalConfig;
function j(e) {
	return e && Object.assign(A, e), A;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/errors.js
function We() {
	let e = this._zod;
	return e.message ??= JSON.stringify(e.def, a, 2), e.message;
}
function Ge(e) {
	this._zod.message = e;
}
var Ke = {
	get: We,
	set: Ge,
	enumerable: !0,
	configurable: !0
}, qe = {
	value: void 0,
	enumerable: !1
}, Je = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), Ye = (e, t) => {
	e.name = "$ZodError", qe.value = t, Object.defineProperty(e, "issues", qe), qe.value = void 0, Object.defineProperty(e, "message", Ke);
	let n = Object.getPrototypeOf(e);
	Je.has(n) || (Je.add(n), Object.defineProperty(n, "toString", {
		configurable: !0,
		enumerable: !1,
		get() {
			let e = () => this.message;
			return Object.defineProperty(this, "toString", {
				value: e,
				configurable: !0,
				writable: !0
			}), e;
		},
		set(e) {
			Object.defineProperty(this, "toString", {
				value: e,
				configurable: !0,
				writable: !0
			});
		}
	}));
}, Xe = O("$ZodError", Ye);
O("$ZodError", Ye, void 0, { Parent: Error });
function Ze(e, t, n) {
	return Object.prototype.hasOwnProperty.call(e, t) || (t === "__proto__" ? Object.defineProperty(e, t, {
		value: n(),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : e[t] = n()), e[t];
}
function Qe(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? Ze(n, i.path[0], () => []).push(t(i)) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function $e(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e, i = []) => {
		for (let a of e.issues) if (a.code === "invalid_union" && a.errors.length) a.errors.map((e) => r({ issues: e }, [...i, ...a.path]));
		else if (a.code === "invalid_key") r({ issues: a.issues }, [...i, ...a.path]);
		else if (a.code === "invalid_element") r({ issues: a.issues }, [...i, ...a.path]);
		else {
			let e = [...i, ...a.path];
			if (e.length === 0) n._errors.push(t(a));
			else {
				let r = n, i = 0;
				for (; i < e.length;) {
					let n = e[i], o = i === e.length - 1;
					if (n === "_errors") {
						o && r._errors.push(t(a)), i++;
						continue;
					}
					Object.prototype.hasOwnProperty.call(r, n) || Object.defineProperty(r, n, {
						value: { _errors: [] },
						enumerable: !0,
						writable: !0,
						configurable: !0
					});
					let s = r[n];
					o && s._errors.push(t(a)), r = s, i++;
				}
			}
		}
	};
	return r(e), n;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/parse.js
function et(e, t) {
	return {
		callee: t?.callee ?? e,
		Err: t?.Err
	};
}
var tt = (e) => {
	let t = (n, r, i, a) => {
		let o = i ? {
			...i,
			async: !1
		} : { async: !1 }, s = n._zod.run({
			value: r,
			issues: []
		}, o);
		if (s instanceof Promise) throw new k();
		if (s.issues.length) {
			let n = new ((a?.Err) ?? e)(s.issues.map((e) => C(e, o, j())));
			throw re(n, a?.callee ?? t), n;
		}
		return s.value;
	};
	return t;
}, nt = (e) => {
	let t = async (n, r, i, a) => {
		let o = i ? {
			...i,
			async: !0
		} : { async: !0 }, s = n._zod.run({
			value: r,
			issues: []
		}, o);
		if (s instanceof Promise && (s = await s), s.issues.length) {
			let n = new ((a?.Err) ?? e)(s.issues.map((e) => C(e, o, j())));
			throw re(n, a?.callee ?? t), n;
		}
		return s.value;
	};
	return t;
}, rt = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new k();
	return a.issues.length ? it(e, a.issues, i) : {
		success: !0,
		data: a.value
	};
};
function it(e, t, n) {
	let r;
	return {
		success: !1,
		get error() {
			return r || (r = new e(t.map((e) => C(e, n, j()))), t = void 0, n = void 0), r;
		},
		set error(e) {
			r = e, t = void 0, n = void 0;
		}
	};
}
var at = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		async: !0
	} : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? it(e, a.issues, i) : {
		success: !0,
		data: a.value
	};
}, ot = /* @__PURE__ */ Symbol.for("zod.compile.invalid"), st = /* @__PURE__ */ Symbol.for("zod.compile.fallback"), ct = ((e, t, n) => {
	let r = e._zod.bag.validator;
	if (r !== void 0) {
		if (r(t) !== ot) return !0;
		if (r.definite === !0 && n === void 0) return !1;
	}
	return lt(e, t, n);
});
function lt(e, t, n) {
	let r = n ? {
		...n,
		async: !1,
		abortEarly: !0
	} : {
		async: !1,
		abortEarly: !0
	}, i = e._zod.bag.fallbackRun, a;
	if (i ? (r[st] = !0, a = i({
		value: t,
		issues: []
	}, r)) : a = e._zod.run({
		value: t,
		issues: []
	}, r), a instanceof Promise) throw new k();
	return a.issues.length === 0;
}
var ut = async (e, t, n) => {
	let r = n ? {
		...n,
		async: !0,
		abortEarly: !0
	} : {
		async: !0,
		abortEarly: !0
	}, i = e._zod.run({
		value: t,
		issues: []
	}, r);
	return i instanceof Promise && (i = await i), i.issues.length === 0;
}, dt = (e) => {
	let t = tt(e), n = (e, r, i, a) => {
		let o = i ? {
			...i,
			direction: "backward"
		} : { direction: "backward" };
		return t(e, r, o, et(n, a));
	};
	return n;
}, ft = (e) => {
	let t = tt(e), n = (e, r, i, a) => t(e, r, i, et(n, a));
	return n;
}, pt = (e) => {
	let t = nt(e), n = async (e, r, i, a) => {
		let o = i ? {
			...i,
			direction: "backward"
		} : { direction: "backward" };
		return await t(e, r, o, et(n, a));
	};
	return n;
}, mt = (e) => {
	let t = nt(e), n = async (e, r, i, a) => await t(e, r, i, et(n, a));
	return n;
}, ht = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return rt(e)(t, n, i);
}, gt = (e) => (t, n, r) => rt(e)(t, n, r), _t = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return at(e)(t, n, i);
}, vt = (e) => async (t, n, r) => at(e)(t, n, r), yt = /^[cC][0-9a-z]{6,}$/, bt = /^[0-9a-z]+$/, xt = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/, St = /^[0-9a-vA-V]{20}$/, Ct = /^[A-Za-z0-9]{27}$/, wt = /^[a-zA-Z0-9_-]{21}$/;
function Tt(e) {
	return RegExp(`^[a-zA-Z0-9_-]{${e}}$`);
}
var Et = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Dt = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Ot = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, kt = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, At = "^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$";
function jt() {
	return new RegExp(At, "u");
}
var Mt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Nt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Pt = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Ft = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, It = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Lt = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/, Rt = /^https?$/, zt = /^\+[1-9]\d{6,14}$/, Bt = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
function Vt(e) {
	return RegExp(`^${e}$`);
}
var Ht = /*@__PURE__*/ Vt(Bt);
function Ut(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : e.seconds ? `${t}:[0-5]\\d(?:\\.\\d+)?` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Wt(e) {
	return RegExp(`^${Ut(e)}$`);
}
function Gt(e) {
	let t = ["Z"];
	e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let n = `${Ut({
		precision: e.precision,
		seconds: !0
	})}(?:${t.join("|")})`, r = e.local ? `${n}|${Ut({ precision: e.precision })}` : n;
	return RegExp(`^${Bt}T(?:${r})$`);
}
var Kt = /^[\s\S]{0,}$/, qt = /^-?\d+(?:\.\d+)?$/, Jt = /^(?:true|false)$/i, Yt = /^[^A-Z]*$/, Xt = /^[^a-z]*$/, M = /*@__PURE__*/ O("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Zt = (e) => {
	let t = e.value;
	return !c(t) && t.length !== void 0;
}, Qt = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, $t = /*@__PURE__*/ O("$ZodCheckLessThan", (e, t) => {
	M.init(e, t);
	let n = Qt[typeof t.value];
	e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: Qt[typeof r.value] ?? n,
			code: "too_big",
			maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), en = /*@__PURE__*/ O("$ZodCheckGreaterThan", (e, t) => {
	M.init(e, t);
	let n = Qt[typeof t.value];
	e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: Qt[typeof r.value] ?? n,
			code: "too_small",
			minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), tn = /*@__PURE__*/ O("$ZodCheckMultipleOf", (e, t) => {
	M.init(e, t), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? t.value !== BigInt(0) && n.value % t.value === BigInt(0) : u(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), nn = /*@__PURE__*/ O("$ZodCheckNumberFormat", (e, t) => {
	M.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = de[t.format];
	e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		});
	};
}), rn = /*@__PURE__*/ O("$ZodCheckMaxLength", (e, t) => {
	var n;
	M.init(e, t), (n = e._zod.def).when ?? (n.when = Zt), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if ((typeof r == "string" && i > t.maximum ? Ee(r) : i) <= t.maximum) return;
		let a = De(r);
		n.issues.push({
			origin: a,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), an = /*@__PURE__*/ O("$ZodCheckMinLength", (e, t) => {
	var n;
	M.init(e, t), (n = e._zod.def).when ?? (n.when = Zt), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if ((typeof r == "string" && i >= t.minimum && i < t.minimum * 2 ? Ee(r) : i) >= t.minimum) return;
		let a = De(r);
		n.issues.push({
			origin: a,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), on = /*@__PURE__*/ O("$ZodCheckLengthEquals", (e, t) => {
	var n;
	M.init(e, t), (n = e._zod.def).when ?? (n.when = Zt), e._zod.check = (n) => {
		let r = n.value, i = r.length, a = typeof r == "string" && i >= t.length && i <= t.length * 2 ? Ee(r) : i;
		if (a === t.length) return;
		let o = De(r), s = a > t.length;
		n.issues.push({
			origin: o,
			...s ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), sn = /*@__PURE__*/ O("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	M.init(e, t), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), cn = /*@__PURE__*/ O("$ZodCheckRegex", (e, t) => {
	sn.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), ln = /*@__PURE__*/ O("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= Yt, sn.init(e, t);
}), un = /*@__PURE__*/ O("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= Xt, sn.init(e, t);
}), dn = /*@__PURE__*/ O("$ZodCheckIncludes", (e, t) => {
	M.init(e, t);
	let n = ce(t.includes);
	t.pattern = new RegExp(typeof t.position == "number" ? `^.{${t.position},}${n}` : n), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), fn = /*@__PURE__*/ O("$ZodCheckStartsWith", (e, t) => {
	M.init(e, t);
	let n = RegExp(`^${ce(t.prefix)}.*`);
	t.pattern ??= n, e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), pn = /*@__PURE__*/ O("$ZodCheckEndsWith", (e, t) => {
	M.init(e, t);
	let n = RegExp(`.*${ce(t.suffix)}$`);
	t.pattern ??= n, e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), mn = /*@__PURE__*/ O("$ZodCheckOverwrite", (e, t) => {
	M.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), hn = class {
	constructor(e = [], t = {}) {
		this.content = [], this.indent = 0, this.args = e, this.closed = t;
	}
	indented(e) {
		this.indent += 1;
		try {
			e(this);
		} finally {
			--this.indent;
		}
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.content ?? [""];
		return new e(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {\n${t.join("\n")}\n};`)(...Object.values(this.closed));
	}
}, gn = {
	major: 4,
	minor: 6,
	patch: 5
}, N = /*@__PURE__*/ O("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = gn;
	let r = e._zod.def.checks, i = e._zod.traits.has("$ZodCheck") ? [e, ...r ?? []] : r?.length ? [...r] : [];
	for (let t of i) for (let n of t._zod.onattach) n(e);
	if (i.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (t, n, r) => {
			if (t.memo) return t;
			let i = x(t), a;
			for (let o of n) {
				if (o._zod.def.when) {
					if (Se(t) || !o._zod.def.when(t)) continue;
				} else if (i) continue;
				let n = t.issues.length, s = o._zod.check(t);
				if (s instanceof Promise && r?.async === !1) throw new k();
				if (a || s instanceof Promise) a = (a ?? Promise.resolve()).then(async () => {
					await s, t.issues.length !== n && (we(t.issues, n, e), i ||= x(t, n));
				});
				else {
					if (t.issues.length === n) continue;
					we(t.issues, n, e), i ||= x(t, n);
				}
			}
			return a ? a.then(() => t) : t;
		}, n = (n, r, a) => {
			if (x(n)) return n.aborted = !0, n;
			let o = t(r, i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new k();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (r, a) => {
			if (a.skipChecks) return e._zod.parse(r, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: r.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, r, a)) : n(t, r, a);
			}
			let o = e._zod.parse(r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new k();
				return o.then((e) => t(e, i, a));
			}
			return t(o, i, a);
		};
	}
}, {
	get "~standard"() {
		return Ae(this, "~standard", yn(this));
	},
	set "~standard"(e) {
		T(this, "~standard", e);
	}
}), _n = (e, t) => e.issues.length ? { issues: e.issues.map((e) => C(e, t, j())) } : { value: e.value };
async function vn(e, t) {
	let n = { async: !0 };
	return _n(await e._zod.run({
		value: t,
		issues: []
	}, n), n);
}
function yn(e) {
	return {
		validate: (t) => {
			let n = { async: !1 };
			try {
				let r = e._zod.run({
					value: t,
					issues: []
				}, n);
				if (!(r instanceof Promise)) return _n(r, n);
			} catch {}
			return vn(e, t);
		},
		vendor: "zod",
		version: 1
	};
}
var bn = /*@__PURE__*/ O("$ZodString", (e, t) => {
	N.init(e, t), e._zod.pattern = t.pattern ?? Kt, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), P = /*@__PURE__*/ O("$ZodStringFormat", (e, t) => {
	sn.init(e, t), bn.init(e, t);
}), xn = /*@__PURE__*/ O("$ZodGUID", (e, t) => {
	t.pattern ??= Dt, P.init(e, t);
}), Sn = /*@__PURE__*/ O("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= Ot(e);
	} else t.pattern ??= Ot();
	P.init(e, t);
}), Cn = /*@__PURE__*/ O("$ZodEmail", (e, t) => {
	t.pattern ??= kt, P.init(e, t);
});
function wn(e) {
	try {
		return typeof URL < "u" && typeof URL.canParse == "function" ? URL.canParse(e) : (new URL(e), !0);
	} catch {
		return !1;
	}
}
function Tn(e, t) {
	return !("normalize" in t) && !("hostname" in t) && !("protocol" in t) ? wn(e) || 2 : En(e, t);
}
function En(e, t) {
	if (!t.normalize && t.protocol?.source === Rt.source && !/^https?:\/\//i.test(e)) return 1;
	try {
		if (typeof URL < "u") {
			let t = URL;
			if (typeof t.parse == "function") return t.parse(e) ?? 2;
		}
		return new URL(e);
	} catch {
		return 2;
	}
}
var Dn = /[\t\n\r]/g;
function On(e) {
	return e.replace(Dn, "");
}
function kn(e, t) {
	return t.lastIndex = 0, t.test(e.hostname);
}
function An(e, t) {
	return t.lastIndex = 0, t.test(e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol);
}
var jn = /*@__PURE__*/ O("$ZodURL", (e, t) => {
	P.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim(), i = Tn(r, t);
			if (i === 1) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid URL format",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			if (i === 2) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			if (i === !0) {
				n.value = On(r);
				return;
			}
			t.hostname && !kn(i, t.hostname) && n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: t.hostname.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			}), t.protocol && !An(i, t.protocol) && n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			}), n.value = t.normalize ? i.href : On(r);
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), Mn = /*@__PURE__*/ O("$ZodEmoji", (e, t) => {
	t.pattern ??= jt(), P.init(e, t);
}), Nn = /*@__PURE__*/ O("$ZodNanoID", (e, t) => {
	if (t.length !== void 0 && (!Number.isInteger(t.length) || t.length < 1)) throw Error(`Invalid nanoid length: ${t.length}`);
	t.pattern ??= t.length === void 0 ? wt : Tt(t.length), P.init(e, t);
}), Pn = /*@__PURE__*/ O("$ZodCUID", (e, t) => {
	t.pattern ??= yt, P.init(e, t);
}), Fn = /*@__PURE__*/ O("$ZodCUID2", (e, t) => {
	t.pattern ??= bt, P.init(e, t);
}), In = /*@__PURE__*/ O("$ZodULID", (e, t) => {
	t.pattern ??= xt, P.init(e, t);
}), Ln = /*@__PURE__*/ O("$ZodXID", (e, t) => {
	t.pattern ??= St, P.init(e, t);
}), Rn = /*@__PURE__*/ O("$ZodKSUID", (e, t) => {
	t.pattern ??= Ct, P.init(e, t);
}), zn = /*@__PURE__*/ O("$ZodISODateTime", (e, t) => {
	t.pattern ??= Gt(t), P.init(e, t);
}), Bn = /*@__PURE__*/ O("$ZodISODate", (e, t) => {
	t.pattern ??= Ht, P.init(e, t);
}), Vn = /*@__PURE__*/ O("$ZodISOTime", (e, t) => {
	t.pattern ??= Wt(t), P.init(e, t);
}), Hn = /*@__PURE__*/ O("$ZodISODuration", (e, t) => {
	t.pattern ??= Et, P.init(e, t);
}), Un = /*@__PURE__*/ O("$ZodIPv4", (e, t) => {
	t.pattern ??= Mt, P.init(e, t);
}), Wn = /^[0-9a-fA-F:.]+$/;
function Gn(e) {
	return Wn.test(e) ? wn(`http://[${e}]`) : !1;
}
var Kn = /*@__PURE__*/ O("$ZodIPv6", (e, t) => {
	t.pattern ??= Nt, P.init(e, t), e._zod.check = (n) => {
		Gn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "ipv6",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), qn = /*@__PURE__*/ O("$ZodCIDRv4", (e, t) => {
	t.pattern ??= Pt, P.init(e, t);
});
function Jn(e) {
	let t = e.split("/");
	if (t.length !== 2) return !1;
	let [n, r] = t;
	if (!r) return !1;
	let i = Number(r);
	return `${i}` !== r || i < 0 || i > 128 ? !1 : Gn(n);
}
var Yn = /*@__PURE__*/ O("$ZodCIDRv6", (e, t) => {
	t.pattern ??= Ft, P.init(e, t), e._zod.check = (n) => {
		Jn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "cidrv6",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function Xn(e) {
	if (e === "") return !0;
	if (/\s/.test(e) || e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var Zn = /^[0-9a-zA-Z+/]*={0,2}$/, Qn = /*@__PURE__*/ O("$ZodBase64", (e, t) => {
	t.pattern ??= Zn, P.init(e, t), e._zod.check = (n) => {
		Xn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), $n = /^[A-Za-z0-9_-]*$/;
function er(e) {
	if (!$n.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return Xn(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var tr = /*@__PURE__*/ O("$ZodBase64URL", (e, t) => {
	t.pattern ??= $n, P.init(e, t), e._zod.check = (n) => {
		er(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), nr = /*@__PURE__*/ O("$ZodE164", (e, t) => {
	t.pattern ??= zt, P.init(e, t);
});
function rr(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var ir = /*@__PURE__*/ O("$ZodJWT", (e, t) => {
	P.init(e, t), e._zod.check = (n) => {
		rr(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), ar = /*@__PURE__*/ O("$ZodNumber", (e, t) => {
	N.init(e, t), e._zod.pattern = qt, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : String(i) : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), or = /*@__PURE__*/ O("$ZodNumberFormat", (e, t) => {
	nn.init(e, t), ar.init(e, t);
}), sr = /*@__PURE__*/ O("$ZodBoolean", (e, t) => {
	N.init(e, t), e._zod.pattern = Jt, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = !!n.value;
		} catch {}
		let i = n.value;
		return typeof i == "boolean" || n.issues.push({
			expected: "boolean",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
	};
}), cr = /*@__PURE__*/ O("$ZodUnknown", (e, t) => {
	N.init(e, t), e._zod.parse = (e) => e;
}), lr = /*@__PURE__*/ O("$ZodNever", (e, t) => {
	N.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
});
function ur(e, t, n) {
	e.issues.length && t.issues.push(...Ce(n, e.issues)), t.value[n] = e.value;
}
var dr = /*@__PURE__*/ O("$ZodArray", (e, t) => {
	N.init(e, t);
	let n = A.memoizer;
	n?.attach(e), e._zod.parse = (r, i) => {
		let a = r.value;
		if (!Array.isArray(a)) return r.issues.push({
			expected: "array",
			code: "invalid_type",
			input: a,
			inst: e
		}), r;
		r.value = n ? n.alloc(e, r, Array(a.length), i) : Array(a.length);
		let o = [], s = i?.abortEarly;
		for (let e = 0; e < a.length; e++) {
			let n = a[e], c = t.element._zod.run({
				value: n,
				issues: []
			}, i);
			if (c instanceof Promise) o.push(c.then((t) => ur(t, r, e)));
			else if (ur(c, r, e), s && c.issues.length !== 0 && x(c)) break;
		}
		return o.length ? Promise.all(o).then(() => r) : r;
	};
});
function fr(e, t, n, r, i, a) {
	let o = n in r, s = a === "optional";
	if (o || !s || i !== "optional") {
		if (e.issues.length) {
			if (i !== void 0 && s && !o) return;
			t.issues.push(...Ce(n, e.issues));
		}
		if (!o && i === void 0) {
			e.issues.length || t.issues.push({
				code: "invalid_type",
				expected: "nonoptional",
				input: void 0,
				path: [n]
			});
			return;
		}
		e.value === void 0 ? (o || i === "defaulted" && !s) && (t.value[n] = void 0) : t.value[n] = e.value;
	}
}
var pr = [];
function mr(e) {
	let t = Object.keys(e.shape), n = Object.getOwnPropertySymbols(e.shape), r = n.length ? n : pr, i = r.length ? [...t, ...r] : t;
	for (let t of i) if (!e.shape?.[t]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${String(t)}": expected a Zod schema`);
	let a = ue(e.shape);
	return {
		...e,
		allKeys: i,
		symbolKeys: r,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(a)
	};
}
function hr(e, t, n, r, i, a, o) {
	let s = [], c = i.keySet, l = i.catchall._zod, u = l.def.type, d = l.optin, f = l.optout, p = 0;
	for (let i in t) {
		if (o && n.issues.length !== p) {
			if (x(n, p)) break;
			p = n.issues.length;
		}
		if (c.has(i)) continue;
		if (i === "__proto__") {
			u === "never" && s.push(i);
			continue;
		}
		if (u === "never") {
			s.push(i);
			continue;
		}
		let a = l.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => fr(e, n, i, t, d, f))) : fr(a, n, i, t, d, f);
	}
	return s.length && n.issues.push({
		code: "unrecognized_keys",
		keys: s,
		input: t,
		inst: a,
		continue: !0
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var gr = /*@__PURE__*/ O("$ZodObject", (e, t) => {
	N.init(e, t);
	let n = Object.getOwnPropertyDescriptor(t, "shape"), r = n?.get ? n.get.raw : t.shape ?? {};
	if (r) {
		let e = () => {
			let n = { ...r };
			return Object.defineProperty(t, "shape", { value: n }), e.raw = n, n;
		};
		e.raw = r, Object.defineProperty(t, "shape", { get: e });
	}
	let i = s(() => mr(t));
	D(e, "propValues", (e) => {
		let t = e.def.shape, n = {};
		for (let e in t) {
			let r = t[e]._zod;
			if (r.values) {
				Object.prototype.hasOwnProperty.call(n, e) || d(n, e, /* @__PURE__ */ new Set());
				for (let t of r.values) n[e].add(t);
				r.optin !== void 0 && n[e].add(void 0);
			}
		}
		return n;
	});
	let a = ie, o = t.catchall, c, l = A.memoizer;
	l?.attach(e), e._zod.parse = (t, n) => {
		c ??= i.value;
		let r = t.value;
		if (!a(r)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: r,
			inst: e
		}), t;
		t.value = l ? l.alloc(e, t, {}, n) : {};
		let s = [], u = c.shape, d = n?.abortEarly, f = t.issues.length;
		for (let e of c.allKeys) {
			if (d && t.issues.length !== f) {
				if (x(t, f)) break;
				f = t.issues.length;
			}
			if (e === "__proto__") continue;
			let i = u[e], a = i._zod.optin, o = i._zod.optout, c = i._zod.run({
				value: r[e],
				issues: []
			}, n);
			c instanceof Promise ? s.push(c.then((n) => fr(n, t, e, r, a, o))) : fr(c, t, e, r, a, o);
		}
		return o ? hr(s, r, t, n, i.value, e, d === !0) : s.length ? Promise.all(s).then(() => t) : t;
	};
}), _r = /*@__PURE__*/ O("$ZodObjectJIT", (e, t) => {
	gr.init(e, t);
	let n = e._zod.parse, r = s(() => mr(t)), i = A.memoizer, a = (t) => {
		let n = r.value, a = n.symbolKeys, o = new hn(["payload", "ctx"], {
			shape: t,
			inst: e,
			memo: i,
			syms: a
		}), s = (e) => `shape[${e}]._zod.run({ value: input[${e}], issues: [] }, ctx)`, c = (e, t) => `
          let ${e}_ab = false;
          for (let i = 0; i < ${e}.issues.length; i++) {
            const iss = ${e}.issues[i];
            iss.path = iss.path ? [${t}, ...iss.path] : [${t}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${e}_ab = true;
          }
          if (${e}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
		o.write("const input = payload.value;");
		let l = Object.create(null), u = 0;
		for (let e of n.allKeys) l[e] = `key_${u++}`;
		o.write(i ? "const newResult = memo.alloc(inst, payload, {}, ctx);" : "const newResult = {};");
		for (let e of n.allKeys) {
			if (e === "__proto__") continue;
			let n = l[e], r = typeof e == "symbol" ? `syms[${a.indexOf(e)}]` : te(e), i = `${r} in input`, u = t[e], d = u?._zod?.optin, f = d !== void 0, p = u?._zod?.optout === "optional";
			if (o.write(`const ${n} = ${s(r)};`), f && p) {
				let e = d === "optional" ? `${n}_present` : `${n}.value !== undefined || ${n}_present`;
				o.write(`
        const ${n}_present = ${i};
        if (!${n}.issues.length || ${n}_present) {
          if (${n}.issues.length) {${c(n, r)}
          }

          if (${e}) {
            newResult[${r}] = ${n}.value;
          }
        }

      `);
			} else f ? (o.write(`
        if (${n}.issues.length) {${c(n, r)}
        }
      `), d === "defaulted" ? o.write(`newResult[${r}] = ${n}.value;`) : o.write(`
        if (${n}.value !== undefined || ${i}) {
          newResult[${r}] = ${n}.value;
        }
      `)) : o.write(`
        const ${n}_present = ${i};
        if (${n}.issues.length) {${c(n, r)}
        }
        if (!${n}_present && !${n}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${r}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${n}_present) {
          newResult[${r}] = ${n}.value;
        }

      `);
		}
		return o.write("payload.value = newResult;"), o.write("return payload;"), o.compile();
	}, o, c = ie, l = !A.jitless, u = l && ae.value, d = t.catchall, f;
	e._zod.parse = (i, s) => {
		f ??= r.value;
		let p = i.value;
		return c(p) ? l && u && s?.async === !1 && s.jitless !== !0 ? (o ||= a(t.shape), i = o(i, s), d ? hr([], p, i, s, f, e, s?.abortEarly === !0) : i) : n(i, s) : (i.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), i);
	};
});
function vr(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !x(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => C(e, r, j())))
	}), t);
}
var yr = /*@__PURE__*/ O("$ZodUnion", (e, t) => {
	N.init(e, t), D(e, "optin", (e) => e.def.options.some((e) => e._zod.optin === "defaulted") ? "defaulted" : e.def.options.some((e) => e._zod.optin !== void 0) ? "optional" : void 0), D(e, "optout", (e) => e.def.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), D(e, "values", (e) => {
		if (e.def.options.every((e) => e._zod.values)) return new Set(e.def.options.flatMap((e) => Array.from(e._zod.values)));
	}), D(e, "pattern", (e) => {
		if (e.def.options.every((e) => e._zod.pattern)) {
			let t = e.def.options.map((e) => e._zod.pattern);
			return RegExp(`^(${t.map((e) => l(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1 ? t.options[0]._zod.run : null;
	e._zod.parse = (r, i) => {
		if (n) return n(r, i);
		let a = !1, o = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: r.value,
				issues: []
			}, i);
			if (t instanceof Promise) o.push(t), a = !0;
			else {
				if (t.issues.length === 0) return t;
				o.push(t);
			}
		}
		return a ? Promise.all(o).then((t) => vr(t, r, e, i)) : vr(o, r, e, i);
	};
}), br = /*@__PURE__*/ O("$ZodIntersection", (e, t) => {
	N.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => Sr(e, t, n)) : Sr(e, i, a);
	};
});
function xr(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (v(e) && v(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		Object.prototype.hasOwnProperty.call(i, "__proto__") && delete i.__proto__;
		for (let n of r) {
			if (n === "__proto__") continue;
			let r = xr(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = xr(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function Sr(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i, a = /* @__PURE__ */ new Map(), o = (e, t) => {
		let n;
		if (e.code === "unrecognized_keys" && !e.path?.length) i ??= e, n = e.keys;
		else if (e.code === "invalid_key" && e.origin === "record" && e.path?.length === 1) {
			let t = String(e.path[0]);
			a.has(t) || a.set(t, e), n = [t];
		} else return !1;
		for (let e of n) r.has(e) || r.set(e, {}), r.get(e)[t] = !0;
		return !0;
	};
	for (let n of t.issues) o(n, "l") || e.issues.push(n);
	for (let t of n.issues) o(t, "r") || e.issues.push(t);
	let s = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (s.length) {
		let t = i ? s.filter((e) => i.keys.includes(e)) : [];
		t.length && e.issues.push({
			...i,
			keys: t
		});
		for (let n of s) !t.includes(n) && a.has(n) && e.issues.push(a.get(n));
	}
	let c = xr(t.value, n.value);
	if (!c.valid) {
		if (x(e)) return e;
		throw Error(`Unmergable intersection. Error path: ${JSON.stringify(c.mergeErrorPath)}`);
	}
	return e.value = c.data, e;
}
var Cr = /*@__PURE__*/ O("$ZodEnum", (e, t) => {
	N.init(e, t);
	let n = r(t.entries), i = new Set(n);
	e._zod.values = i, D(e, "pattern", (e) => {
		let t = r(e.def.entries).filter((e) => se.has(typeof e));
		return RegExp(t.length ? `^(${t.map((e) => ce(e.toString())).join("|")})$` : "^[^\\s\\S]$");
	}), e._zod.parse = (t, r) => {
		let a = t.value;
		return i.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), wr = /*@__PURE__*/ O("$ZodTransform", (e, t) => {
	N.init(e, t), e._zod.optin = "optional", A.memoizer?.guard(e), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new Ue(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n));
		if (i instanceof Promise) throw new k();
		return n.value = i, n;
	};
});
function Tr(e, t) {
	return e.value = t.issues.length ? void 0 : t.value, e;
}
var Er = /*@__PURE__*/ O("$ZodOptional", (e, t) => {
	N.init(e, t), D(e, "optin", (e) => e.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), e._zod.optout = "optional", D(e, "values", (e) => {
		let t = e.def.innerType._zod.values;
		return t ? /* @__PURE__ */ new Set([...t, void 0]) : void 0;
	}), D(e, "pattern", (e) => {
		let t = e.def.innerType._zod.pattern;
		return t ? RegExp(`^(${l(t.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (e.value === void 0) {
			if (t.innerType._zod.optin !== "defaulted") return e;
			let r = t.innerType._zod.run({
				value: e.value,
				issues: []
			}, n);
			return r instanceof Promise ? r.then((t) => Tr(e, t)) : Tr(e, r);
		}
		return t.innerType._zod.run(e, n);
	};
}), Dr = /*@__PURE__*/ O("$ZodExactOptional", (e, t) => {
	Er.init(e, t), D(e, "values", (e) => e.def.innerType._zod.values), D(e, "pattern", (e) => e.def.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
}), Or = /*@__PURE__*/ O("$ZodNullable", (e, t) => {
	N.init(e, t), D(e, "optin", (e) => e.def.innerType._zod.optin), D(e, "optout", (e) => e.def.innerType._zod.optout), D(e, "pattern", (e) => {
		let t = e.def.innerType._zod.pattern;
		return t ? RegExp(`^(${l(t.source)}|null)$`) : void 0;
	}), D(e, "values", (e) => e.def.innerType._zod.values ? /* @__PURE__ */ new Set([...e.def.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), kr = /*@__PURE__*/ O("$ZodDefault", (e, t) => {
	N.init(e, t), e._zod.optin = "defaulted", D(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => Ar(e, t)) : Ar(r, t);
	};
});
function Ar(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var jr = /*@__PURE__*/ O("$ZodPrefault", (e, t) => {
	N.init(e, t), e._zod.optin = "defaulted", D(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), Mr = /*@__PURE__*/ O("$ZodNonOptional", (e, t) => {
	N.init(e, t), D(e, "values", (e) => {
		let t = e.def.innerType._zod.values;
		return t ? new Set([...t].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => Nr(t, e)) : Nr(i, e);
	};
});
function Nr(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
function Pr(e, t, n, r) {
	return t.issues.length ? (e.value = n.catchValue({
		...t,
		value: e.value,
		error: { issues: t.issues.map((e) => C(e, r, j())) },
		input: e.value
	}), e) : (e.value = t.value, t.memo && (e.memo = !0), e);
}
var Fr = /*@__PURE__*/ O("$ZodCatch", (e, t) => {
	N.init(e, t), D(e, "optin", (e) => e.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), D(e, "optout", (e) => e.def.innerType._zod.optout), D(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run({
			value: e.value,
			issues: []
		}, n);
		return r instanceof Promise ? r.then((r) => Pr(e, r, t, n)) : Pr(e, r, t, n);
	};
}), Ir = /*@__PURE__*/ O("$ZodPipe", (e, t) => {
	N.init(e, t), D(e, "values", (e) => e.def.in._zod.values), D(e, "optin", (e) => e.def.in._zod.optin), D(e, "optout", (e) => e.def.out._zod.optout), D(e, "propValues", (e) => e.def.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => Lr(e, t.in, n)) : Lr(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => Lr(e, t.out, n)) : Lr(r, t.out, n);
	};
});
function Lr(e, t, n) {
	return e.issues.some((e) => e.code !== "unrecognized_keys") ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues
	}, n);
}
var Rr = /*@__PURE__*/ O("$ZodReadonly", (e, t) => {
	N.init(e, t), D(e, "propValues", (e) => e.def.innerType._zod.propValues), D(e, "values", (e) => e.def.innerType._zod.values), D(e, "optin", (e) => e.def.innerType?._zod?.optin), D(e, "optout", (e) => e.def.innerType?._zod?.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(zr) : zr(r);
	};
});
function zr(e) {
	return e.memo || (e.value = Object.freeze(e.value)), e;
}
var Br = /*@__PURE__*/ O("$ZodCustom", (e, t) => {
	M.init(e, t), N.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => Vr(t, n, r, e));
		Vr(i, n, r, e);
	};
});
function Vr(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(w(e));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/memoizer.js
var Hr = class extends Error {
	constructor() {
		super("Cannot parse a reference cycle that closes through a transform"), this.name = "ZodCyclicError";
	}
}, Ur = "~memo", Wr = [];
function Gr(e) {
	return typeof e == "object" && !!e;
}
function Kr(e) {
	return e.map((e) => e.path ? {
		...e,
		path: e.path.slice()
	} : { ...e });
}
var qr = /*@__PURE__*/ new WeakMap(), F = 0, Jr = 1, I = 2;
function Yr(e, t, n) {
	let r = qr.get(e);
	if (r !== void 0) return r ? I : F;
	if (t.has(e)) return I;
	t.add(e);
	let i = F, a = (e) => {
		if (i !== I && e?._zod) {
			let r = Yr(e, t, n);
			r > i && (i = r);
		}
	}, o = (e, r) => {
		let i = F;
		for (let a of Reflect.ownKeys(e)) {
			let o = Object.getOwnPropertyDescriptor(e, a);
			if (r && !o.enumerable) continue;
			let s = o.get ? Jr : o.value?._zod ? Yr(o.value, t, n) : F;
			s > i && (i = s);
		}
		return i;
	}, s = (e) => {
		e > i && (i = e);
	}, c = e._zod.def;
	switch (c.type) {
		case "object": {
			let e = f(c);
			s(e ? o(e, !0) : Jr), a(c.catchall);
			break;
		}
		case "array":
			a(c.element);
			break;
		case "tuple":
			for (let e of c.items) a(e);
			a(c.rest);
			break;
		case "record":
		case "map":
			a(c.keyType), a(c.valueType);
			break;
		case "set":
			a(c.valueType);
			break;
		case "union":
			for (let e of c.options) a(e);
			break;
		case "intersection":
			a(c.left), a(c.right);
			break;
		case "optional":
		case "nullable":
		case "default":
		case "prefault":
		case "catch":
		case "readonly":
		case "nonoptional":
		case "promise":
		case "success":
			a(c.innerType);
			break;
		case "pipe":
			a(c.in), a(c.out);
			break;
		case "function":
			a(c.input), a(c.output);
			break;
		case "lazy": {
			let r = c._cachedInner ?? (n ? e._zod.innerType : void 0);
			s(r ? Yr(r, t, !1) : Jr);
			break;
		}
		case "template_literal":
		case "string":
		case "number":
		case "int":
		case "boolean":
		case "bigint":
		case "symbol":
		case "undefined":
		case "null":
		case "void":
		case "never":
		case "any":
		case "unknown":
		case "date":
		case "nan":
		case "enum":
		case "literal":
		case "file":
		case "transform":
		case "custom": break;
		default: for (let e in c) {
			let t = Object.getOwnPropertyDescriptor(c, e);
			if (!t || t.get) continue;
			let n = t.value;
			if (n && typeof n == "object") {
				if (n._zod) a(n);
				else if (Array.isArray(n)) for (let e of n) a(e);
			}
		}
	}
	return t.delete(e), Xr(e, i);
}
function Xr(e, t) {
	return t !== Jr && qr.set(e, t === I), t;
}
function Zr(e, t) {
	let n = e.buckets.get(t);
	return n || (n = /* @__PURE__ */ new WeakMap(), e.buckets.set(t, n)), n;
}
var Qr, $r = [], ei = {
	alloc(e, t, n) {
		let r = Qr;
		if (!r) return n;
		Qr = void 0;
		let i = {
			value: n,
			issues: null
		};
		return r.set(t.value, i), $r.push(i), n;
	},
	guard(e) {
		var t;
		(t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
			let t = e._zod.parse, n = (e, n) => {
				if (n.direction !== "backward" && ni(n, e.value)) throw new Hr();
				return t(e, n);
			};
			e._zod.parse = n, e._zod.run === t && (e._zod.run = n);
		});
	},
	attach(e) {
		var t;
		let n, r = !1, i, a;
		(t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
			let t = e._zod.parse, o = (s, c) => {
				if (n === void 0) {
					let i = Yr(e, /* @__PURE__ */ new Set(), !1);
					if (i === F) return e._zod.parse = t, e._zod.run === o && (e._zod.run = t), t(s, c);
					i === I || r ? n = !0 : r = !0;
				}
				let l = s.value;
				if (!Gr(l)) return t(s, c);
				let u = c[Ur];
				u || (u = {
					buckets: /* @__PURE__ */ new WeakMap(),
					backEdges: void 0
				}, c[Ur] = u);
				let d;
				i === c ? d = a : (d = Zr(u, e), i = c, a = d);
				let f = d.get(l);
				if (f) return s.value = f.value, f.issues ? f.issues.length && s.issues.push(...Kr(f.issues)) : (s.memo = !0, u.backEdges ?? (u.backEdges = /* @__PURE__ */ new WeakSet()), u.backEdges.add(f.value)), s;
				Qr = d;
				let p = $r.length, m = t(s, c);
				Qr = void 0;
				let h = $r.length > p ? $r.pop() : void 0;
				return m instanceof Promise ? m.then((e) => (h && (h.issues = e.issues.length ? Kr(e.issues) : Wr), e)) : (h && (h.issues = m.issues.length ? Kr(m.issues) : Wr), m);
			};
			e._zod.parse = o, e._zod.run === t && (e._zod.run = o);
		});
	}
};
function ti() {
	return ei;
}
function ni(e, t) {
	let n = e[Ur]?.backEdges;
	return n !== void 0 && Gr(t) && n.has(t);
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/locales/en.js
var ri = () => {
	let e = {
		string: {
			unit: "characters",
			verb: "to have"
		},
		file: {
			unit: "bytes",
			verb: "to have"
		},
		array: {
			unit: "items",
			verb: "to have"
		},
		set: {
			unit: "items",
			verb: "to have"
		},
		map: {
			unit: "entries",
			verb: "to have"
		}
	};
	function t(t) {
		return e[t] ?? null;
	}
	let n = {
		regex: "input",
		email: "email address",
		url: "URL",
		emoji: "emoji",
		uuid: "UUID",
		uuidv4: "UUIDv4",
		uuidv6: "UUIDv6",
		nanoid: "nanoid",
		guid: "GUID",
		cuid: "cuid",
		cuid2: "cuid2",
		ulid: "ULID",
		xid: "XID",
		ksuid: "KSUID",
		datetime: "ISO datetime",
		date: "ISO date",
		time: "ISO time",
		duration: "ISO duration",
		ipv4: "IPv4 address",
		ipv6: "IPv6 address",
		mac: "MAC address",
		cidrv4: "IPv4 range",
		cidrv6: "IPv6 range",
		base64: "base64-encoded string",
		base64url: "base64url-encoded string",
		json_string: "JSON string",
		e164: "E.164 number",
		currency_code: "currency code",
		credit_card: "credit card number",
		iban: "IBAN",
		jwt: "JWT",
		template_literal: "input"
	}, r = { nan: "NaN" };
	function a(e, t) {
		return e === "number" && typeof t == "number" && !Number.isFinite(t) ? String(t) : r[e] ?? e;
	}
	return (e) => {
		switch (e.code) {
			case "invalid_type": return `Invalid input: expected ${a(e.expected)}, received ${a(Oe(e.input), e.input)}`;
			case "invalid_value": return e.values.length === 1 ? `Invalid input: expected ${le(e.values[0])}` : `Invalid option: expected one of ${i(e.values, "|")}`;
			case "too_big": {
				let n = e.exact ? "exactly " : e.inclusive ? "<=" : "<", r = t(e.origin);
				return r ? `Too big: expected ${e.origin ?? "value"} to have ${n}${e.maximum.toString()} ${r.unit ?? "elements"}` : `Too big: expected ${e.origin ?? "value"} to be ${n}${e.maximum.toString()}`;
			}
			case "too_small": {
				let n = e.exact ? "exactly " : e.inclusive ? ">=" : ">", r = t(e.origin);
				return r ? `Too small: expected ${e.origin} to have ${n}${e.minimum.toString()} ${r.unit}` : `Too small: expected ${e.origin} to be ${n}${e.minimum.toString()}`;
			}
			case "invalid_format": {
				let t = e;
				return t.format === "starts_with" ? `Invalid string: must start with "${t.prefix}"` : t.format === "ends_with" ? `Invalid string: must end with "${t.suffix}"` : t.format === "includes" ? `Invalid string: must include "${t.includes}"` : t.format === "regex" ? `Invalid string: must match pattern ${t.pattern}` : `Invalid ${n[t.format] ?? e.format}`;
			}
			case "not_multiple_of": return `Invalid number: must be a multiple of ${e.divisor}`;
			case "unrecognized_keys": return `Unrecognized key${e.keys.length > 1 ? "s" : ""}: ${i(e.keys, ", ")}`;
			case "invalid_key": return `Invalid key in ${e.origin}`;
			case "invalid_union": return e.options && Array.isArray(e.options) && e.options.length > 0 ? `Invalid discriminator value. Expected ${e.options.map((e) => `'${e}'`).join(" | ")}` : e.inclusive === !1 ? "Invalid input: more than one option matched" : "Invalid input";
			case "invalid_element": return `Invalid value in ${e.origin}`;
			default: return "Invalid input";
		}
	};
};
function ii() {
	return { localeError: ri() };
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/registries.js
var ai, oi = class {
	constructor() {
		this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function si() {
	return new oi();
}
(ai = globalThis).__zod_globalRegistry ?? (ai.__zod_globalRegistry = si());
var L = globalThis.__zod_globalRegistry;
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/api.js
function ci(e) {
	return e.checks &&= [...e.checks], e;
}
// @__NO_SIDE_EFFECTS__
function li(e, t) {
	return new e(ci({
		type: "string",
		...b(t)
	}));
}
// @__NO_SIDE_EFFECTS__
function ui(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function di(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function fi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function pi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function mi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function hi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function gi(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function _i(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function vi(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function yi(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function bi(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function xi(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Si(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ci(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function wi(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ti(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ei(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Di(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Oi(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ki(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ai(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ji(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Mi(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ni(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Pi(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Fi(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ii(e, t) {
	return new e(ci({
		type: "number",
		checks: [],
		...b(t)
	}));
}
// @__NO_SIDE_EFFECTS__
function Li(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ri(e, t) {
	return new e({
		type: "boolean",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function zi(e) {
	return new e({ type: "unknown" });
}
// @__NO_SIDE_EFFECTS__
function Bi(e, t) {
	return new e({
		type: "never",
		...b(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Vi(e, t) {
	return new $t({
		check: "less_than",
		...b(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function Hi(e, t) {
	return new $t({
		check: "less_than",
		...b(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function Ui(e, t) {
	return new en({
		check: "greater_than",
		...b(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function Wi(e, t) {
	return new en({
		check: "greater_than",
		...b(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function Gi(e, t) {
	return new tn({
		check: "multiple_of",
		...b(t),
		value: e
	});
}
// @__NO_SIDE_EFFECTS__
function Ki(e, t) {
	return new rn({
		check: "max_length",
		...b(t),
		maximum: e
	});
}
// @__NO_SIDE_EFFECTS__
function qi(e, t) {
	return new an({
		check: "min_length",
		...b(t),
		minimum: e
	});
}
// @__NO_SIDE_EFFECTS__
function Ji(e, t) {
	return new on({
		check: "length_equals",
		...b(t),
		length: e
	});
}
// @__NO_SIDE_EFFECTS__
function Yi(e, t) {
	return new cn({
		check: "string_format",
		format: "regex",
		...b(t),
		pattern: e
	});
}
// @__NO_SIDE_EFFECTS__
function Xi(e) {
	return new ln({
		check: "string_format",
		format: "lowercase",
		...b(e)
	});
}
// @__NO_SIDE_EFFECTS__
function Zi(e) {
	return new un({
		check: "string_format",
		format: "uppercase",
		...b(e)
	});
}
// @__NO_SIDE_EFFECTS__
function Qi(e, t) {
	return new dn({
		check: "string_format",
		format: "includes",
		...b(t),
		includes: e
	});
}
// @__NO_SIDE_EFFECTS__
function $i(e, t) {
	return new fn({
		check: "string_format",
		format: "starts_with",
		...b(t),
		prefix: e
	});
}
// @__NO_SIDE_EFFECTS__
function ea(e, t) {
	return new pn({
		check: "string_format",
		format: "ends_with",
		...b(t),
		suffix: e
	});
}
// @__NO_SIDE_EFFECTS__
function R(e) {
	return new mn({
		check: "overwrite",
		tx: e
	});
}
// @__NO_SIDE_EFFECTS__
function ta(e) {
	return /* @__PURE__ */ R((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function na() {
	return /* @__PURE__ */ R((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function ra() {
	return /* @__PURE__ */ R((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function ia() {
	return /* @__PURE__ */ R((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function aa() {
	return /* @__PURE__ */ R((e) => ne(e));
}
// @__NO_SIDE_EFFECTS__
function oa(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...b(n)
	});
}
// @__NO_SIDE_EFFECTS__
function sa(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...b(n)
	});
}
// @__NO_SIDE_EFFECTS__
function ca(e, t) {
	let n = /* @__PURE__ */ la((t) => (t.addIssue = (e) => {
		if (typeof e == "string") t.issues.push(w(e, t.value, n._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", "input" in r || (r.input = t.value), r.inst ??= n, r.continue ??= !n._zod.def.abort, t.issues.push(w(r));
		}
	}, e(t.value, t)), t);
	return n;
}
// @__NO_SIDE_EFFECTS__
function la(e, t) {
	let n = new M({
		check: "custom",
		...b(t)
	});
	return n._zod.check = e, n;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/core/to-json-schema.js
function z(e, ...t) {
	for (let n of t) for (let t of Reflect.ownKeys(n)) Object.prototype.propertyIsEnumerable.call(n, t) && d(e, t, n[t]);
	return e;
}
function ua(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? L,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		sharedDefsExtractedFor: void 0,
		sharedEmitDoneFor: void 0,
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		intersections: [],
		deferred: [],
		external: e?.external ?? void 0
	};
}
function B(e, t, n, r, i) {
	let a = typeof t.unrepresentable == "function" ? t.unrepresentable({
		zodSchema: e,
		path: r.path,
		message: i
	}) : t.unrepresentable;
	if (a === "any") return !1;
	if (a === void 0 || a === "throw") throw Error(i);
	return Object.assign(n, a), !0;
}
function V(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o), t.sharedDefsExtractedFor = void 0, t.sharedEmitDoneFor = void 0;
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, V(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && z(o.schema, c), t.io === "input" && H(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function da(e) {
	return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function fa(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	if (e.external && e.sharedDefsExtractedFor === e.external) return;
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${da(a)}`
			};
		}
		let i = `#/${r}/`;
		if (t[1] === n && !t[1].schema.id) return { ref: "#" };
		let a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + da(a)
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) {
			a(n);
			continue;
		}
		if (e.external) {
			let r = e.external.registry.get(n[0])?.id;
			if (t !== n[0] && r) {
				a(n);
				continue;
			}
		}
		if (e.metadataRegistry.get(n[0])?.id) {
			a(n);
			continue;
		}
		if (r.cycle) {
			a(n);
			continue;
		}
		r.count > 1 && e.reused === "ref" && a(n);
	}
	e.external && (e.sharedDefsExtractedFor = e.external);
}
function pa(e) {
	let t = e.anyOf;
	if (!Array.isArray(t) || t.length === 0 || e.type !== void 0) return;
	let n = [];
	for (let e of t) {
		if (!e || typeof e != "object") return;
		pa(e);
		let t = Object.keys(e);
		if (t.length !== 1 || t[0] !== "type") return;
		let r = e.type;
		for (let e of Array.isArray(r) ? r : [r]) {
			if (typeof e != "string") return;
			n.includes(e) || n.push(e);
		}
	}
	delete e.anyOf, e.type = n.length === 1 ? n[0] : n;
}
var ma = /* @__PURE__ */ new Set([
	"type",
	"properties",
	"required",
	"additionalProperties"
]), ha = ["oneOf", "anyOf"];
function ga(e) {
	let t = e.additionalProperties;
	return t === void 0 || t === !1 || typeof t != "object" || !t ? null : Object.keys(t).length ? t : null;
}
function _a(e) {
	let t = [];
	for (let n of e) {
		if (typeof n != "object" || n.type !== "object") return null;
		for (let e in n) if (!ma.has(e)) return null;
		t.push(n);
	}
	let n = {}, r = /* @__PURE__ */ new Set();
	for (let e of t) {
		for (let r in e.properties) {
			if (Object.prototype.hasOwnProperty.call(n, r)) continue;
			let e = [];
			for (let n of t) {
				let t = n.properties?.[r] ?? ga(n);
				t != null && (e.some((e) => JSON.stringify(e) === JSON.stringify(t)) || e.push(t));
			}
			d(n, r, e.length === 1 ? e[0] : _a(e) ?? { allOf: e });
		}
		for (let t of e.required ?? []) r.add(t);
	}
	let i = {
		type: "object",
		properties: n
	};
	if (r.size && (i.required = [...r]), t.every((e) => e.additionalProperties === !1)) i.additionalProperties = !1;
	else {
		let e = [];
		for (let n of t) {
			let t = ga(n);
			t && !e.some((e) => JSON.stringify(e) === JSON.stringify(t)) && e.push(t);
		}
		e.length === 1 ? i.additionalProperties = e[0] : e.length > 1 && (i.additionalProperties = { allOf: e });
	}
	return i;
}
function va(e) {
	let t = e.allOf;
	if (!Array.isArray(t) || t.length < 2) return;
	for (let t of ma) if (t in e) return;
	let n = t.filter((e) => ha.some((t) => Array.isArray(e[t]))), r = null;
	if (!n.length) r = _a(t);
	else {
		let e = n[0], i = ha.find((t) => Array.isArray(e[t]));
		if (Object.keys(e).length !== 1) return;
		let a = t.filter((t) => t !== e), o = e[i].map((e) => _a([...a, e]));
		if (o.some((e) => !e)) return;
		r = { [i]: o };
	}
	r && (delete e.allOf, z(e, r));
}
function ya(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : z(i, s), z(i, a), t._zod.parent === o) for (let e in i) e !== "$ref" && e !== "allOf" && (e in a || delete i[e]);
			if (s.$ref && n.def) for (let e in i) e !== "$ref" && e !== "allOf" && e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e !== "$ref" && e !== "allOf" && e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	if (!e.external || e.sharedEmitDoneFor !== e.external) {
		for (let t of [...e.seen.entries()].reverse()) r(t[0]);
		if (e.target !== "openapi-3.0") for (let t of e.seen.entries()) pa(t[1].def ?? t[1].schema);
		for (let t of e.deferred) t();
		if (e.intersections.length) {
			let t = /* @__PURE__ */ new Map();
			for (let n of e.seen.values()) for (let e of [n.schema, n.def]) {
				let n = e?.allOf;
				if (!Array.isArray(n)) continue;
				let r = t.get(n);
				r ? r.push(e) : t.set(n, [e]);
			}
			for (let n of e.intersections) for (let e of t.get(n) ?? []) va(e);
		}
	}
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	z(i, n.defId ? n.schema : n.def ?? n.schema);
	let a = e.metadataRegistry.get(t)?.id;
	a !== void 0 && i.id === a && delete i.id;
	let o = e.external?.defs ?? {};
	if (!e.external || e.sharedEmitDoneFor !== e.external) for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (e.def.id === e.defId && delete e.def.id, d(o, e.defId, e.def));
	}
	e.external && (e.sharedEmitDoneFor = e.external), e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: xa(t, "input", e.processors),
					output: xa(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function H(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return H(r.element, n);
	if (r.type === "set") return H(r.valueType, n);
	if (r.type === "lazy") return H(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault" || r.type === "catch") return H(r.innerType, n);
	if (r.type === "intersection") return H(r.left, n) || H(r.right, n);
	if (r.type === "record" || r.type === "map") return H(r.keyType, n) || H(r.valueType, n);
	if (r.type === "pipe") return e._zod.traits.has("$ZodCodec") ? !0 : H(r.in, n) || H(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (H(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (H(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (H(e, n)) return !0;
		return !!(r.rest && H(r.rest, n));
	}
	return !1;
}
var ba = (e, t = {}) => (n) => {
	let r = ua({
		...n,
		processors: t
	});
	return V(e, r), fa(r, e), ya(r, e);
}, xa = (e, t, n = {}) => (r) => {
	let { libraryOptions: i, target: a } = r ?? {}, o = ua({
		...i ?? {},
		target: a,
		io: t,
		processors: n
	});
	return V(e, o), fa(o, e), ya(o, e);
}, U = (e, t, n) => {
	(e[t] === void 0 || n > e[t]) && (e[t] = n);
}, W = (e, t, n) => {
	(e[t] === void 0 || n < e[t]) && (e[t] = n);
}, Sa = (e, t) => {
	U(e, "minimum", t), W(e, "maximum", t);
}, Ca = (e, t) => {
	e.multipleOf ??= [], e.multipleOf.includes(t) || e.multipleOf.push(t);
}, wa = (e, t) => {
	e.patterns ??= /* @__PURE__ */ new Set(), e.patterns.add(t);
}, Ta = (e, t) => {
	e.mime = e.mime ? e.mime.filter((e) => t.includes(e)) : [...t];
}, Ea = (e, t) => {
	e.format = t, t.includes("int") && (e.isInt = !0);
}, Da = (e, t) => U(e, "minimum", t.minimum), Oa = (e, t) => W(e, "maximum", t.maximum), ka = (e) => (t, n) => {
	Ea(t, n.format);
	let [r, i] = e[n.format];
	U(t, "minimum", r), W(t, "maximum", i);
}, Aa = {
	greater_than: (e, t) => U(e, t.inclusive ? "minimum" : "exclusiveMinimum", t.value),
	less_than: (e, t) => W(e, t.inclusive ? "maximum" : "exclusiveMaximum", t.value),
	multiple_of: (e, t) => Ca(e, t.value),
	number_format: ka(de),
	bigint_format: ka(fe),
	min_length: Da,
	max_length: Oa,
	length_equals: (e, t) => Sa(e, t.length),
	min_size: Da,
	max_size: Oa,
	size_equals: (e, t) => Sa(e, t.size),
	string_format: (e, t) => {
		Ea(e, t.format), t.pattern && wa(e, t.pattern), (t.format === "base64" || t.format === "base64url") && (e.contentEncoding = t.format), (t.local || t.precision === -1) && (e.laxFormat = !0);
	},
	mime_type: (e, t) => Ta(e, t.mime)
};
function G(e) {
	let t = {}, n = e._zod.def, r = e._zod.traits.has("$ZodCheck") ? [e, ...n.checks ?? []] : n.checks ?? [];
	for (let e of r) Aa[e._zod.def.check]?.(t, e._zod.def);
	let i = e._zod.bag;
	i.minimum !== void 0 && U(t, "minimum", i.minimum), i.exclusiveMinimum !== void 0 && U(t, "exclusiveMinimum", i.exclusiveMinimum), i.maximum !== void 0 && W(t, "maximum", i.maximum), i.exclusiveMaximum !== void 0 && W(t, "exclusiveMaximum", i.exclusiveMaximum), i.multipleOf !== void 0 && Ca(t, i.multipleOf), i.format !== void 0 && (t.format ??= i.format, i.format.includes("int") && (t.isInt = !0)), i.mime && Ta(t, i.mime);
	for (let e of i.patterns ?? []) wa(t, e);
	return t;
}
var ja = {
	guid: "uuid",
	url: "uri",
	datetime: "date-time",
	json_string: "json-string",
	regex: ""
}, Ma = /* @__PURE__ */ new Map([[Zn, It], [$n, Lt]]), Na = (e) => Ma.get(e) ?? e, Pa = (e, t, n, r) => {
	let i = n;
	i.type = "string";
	let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l, laxFormat: u } = G(e);
	if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = ja[s] ?? s, i.format === "" && delete i.format, (s === "time" || u) && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
		let e = [...c].map(Na);
		e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
			...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
			pattern: e.source
		}))]);
	}
}, Fa = (e, t, n, r) => {
	let i = n, { minimum: a, maximum: o, multipleOf: s, exclusiveMaximum: c, exclusiveMinimum: l, isInt: u } = G(e);
	i.type = u ? "integer" : "number";
	let d = typeof l == "number" && l >= (a ?? -Infinity), f = typeof c == "number" && c <= (o ?? Infinity), p = t.target === "draft-04" || t.target === "openapi-3.0";
	if (d ? p ? (i.minimum = l, i.exclusiveMinimum = !0) : i.exclusiveMinimum = l : typeof a == "number" && (i.minimum = a), f ? p ? (i.maximum = c, i.exclusiveMaximum = !0) : i.exclusiveMaximum = c : typeof o == "number" && (i.maximum = o), s) {
		let n = /* @__PURE__ */ new Set();
		for (let a of s) Number.isFinite(a) && a !== 0 ? n.add(Math.abs(a)) : B(e, t, i, r, `A multipleOf divisor of ${a} cannot be represented in JSON Schema`);
		let [a, ...o] = n;
		a !== void 0 && (i.multipleOf = a), o.length && (i.allOf = [...i.allOf ?? [], ...o.map((e) => ({ multipleOf: e }))]);
	}
}, Ia = (e, t, n, r) => {
	n.type = "boolean";
}, La = (e, t, n, r) => {
	n.not = {};
}, Ra = (e, t, n, i) => {
	let a = e._zod.def, o = r(a.entries);
	if (o.length === 0) {
		n.not = {};
		return;
	}
	o.every((e) => typeof e == "number") && (n.type = "number"), o.every((e) => typeof e == "string") && (n.type = "string"), n.enum = o;
}, za = (e, t, n, r) => {
	B(e, t, n, r, "Custom types cannot be represented in JSON Schema");
}, Ba = (e, t, n, r) => {
	B(e, t, n, r, "Transforms cannot be represented in JSON Schema");
}, Va = (e, t, n, r) => {
	let i = n, a = e._zod.def, { minimum: o, maximum: s } = G(e);
	typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = V(a.element, t, {
		...r,
		path: [...r.path, "items"]
	});
};
function Ha(e) {
	let t = e._zod.def;
	return t.type === "pipe" && t.in._zod.traits.has("$ZodTransform") ? Ha(t.out) : t.type === "catch" ? Ha(t.innerType) : e._zod.optin;
}
var Ua = (e, t, n, r) => {
	let i = n, a = e._zod.def, o = a.shape;
	if (Object.getOwnPropertySymbols(o).length && B(e, t, i, r, "Symbol keys cannot be represented in JSON Schema")) return;
	i.type = "object", i.properties = {};
	for (let e in o) d(i.properties, e, V(o[e], t, {
		...r,
		path: [
			...r.path,
			"properties",
			e
		]
	}));
	let s = [];
	for (let e of Object.keys(o)) {
		let n = a.shape[e];
		(t.io === "input" ? Ha(n) === void 0 : n._zod.optout === void 0) && s.push(e);
	}
	s.length > 0 && (i.required = s), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = V(a.catchall, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	})) : t.io === "output" && (i.additionalProperties = !1);
}, Wa = (e, t, n, r) => {
	let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => V(e, t, {
		...r,
		path: [
			...r.path,
			a ? "oneOf" : "anyOf",
			n
		]
	}));
	a ? n.oneOf = o : n.anyOf = o;
}, Ga = (e, t, n, r) => {
	let i = e._zod.def, a = V(i.left, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			0
		]
	}), o = V(i.right, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			1
		]
	}), s = (e) => "allOf" in e && Object.keys(e).length === 1, c = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
	n.allOf = c, t.intersections.push(c);
}, Ka = (e, t, n, r) => {
	let i = e._zod.def, a = V(i.innerType, t, r), o = t.seen.get(e);
	t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, qa = (e, t, n, r) => {
	let i = e._zod.def;
	V(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Ja = Symbol();
function Ya(e, t, n, r, i) {
	let a = !1, o = JSON.stringify(e, (e, t) => typeof t == "bigint" ? (a = !0, null) : t);
	return a ? (B(t, n, r, i, "BigInt defaults cannot be represented in JSON Schema"), Ja) : JSON.parse(o);
}
var Xa = (e, t, n, r) => {
	let i = e._zod.def;
	V(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o = Ya(i.defaultValue, e, t, n, r);
	o !== Ja && (n.default = o);
}, Za = (e, t, n, r) => {
	let i = e._zod.def;
	V(i.innerType, t, r);
	let a = t.seen.get(e);
	if (a.ref = i.innerType, t.io !== "input") return;
	let o = Ya(i.defaultValue, e, t, n, r);
	o !== Ja && (n._prefault = o);
}, Qa = (e, t, n, r) => {
	let i = e._zod.def;
	V(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o;
	try {
		o = i.catchValue(void 0);
	} catch {
		B(e, t, n, r, "Dynamic catch values are not supported in JSON Schema");
		return;
	}
	n.default = o;
}, $a = (e, t, n, r) => {
	let i = e._zod.def, a = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? a ? i.out : i.in : i.out;
	V(o, t, r);
	let s = t.seen.get(e);
	s.ref = o;
}, eo = (e, t, n, r) => {
	let i = e._zod.def;
	V(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.readOnly = !0;
}, to = (e, t, n, r) => {
	let i = e._zod.def;
	V(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, no = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]);
function ro(e, t, n) {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		get() {
			let e = n(this);
			return Object.defineProperty(this, t, {
				value: e,
				configurable: !0,
				writable: !0
			}), e;
		},
		set(e) {
			Object.defineProperty(this, t, {
				value: e,
				configurable: !0,
				writable: !0
			});
		}
	});
}
var K = /*@__PURE__*/ O("ZodError", (e, t) => {
	Xe.init(e, t), e.name = "ZodError";
	let n = Object.getPrototypeOf(e);
	no.has(n) || (no.add(n), ro(n, "format", (e) => (t) => $e(e, t)), ro(n, "flatten", (e) => (t) => Qe(e, t)), ro(n, "addIssue", (e) => (t) => {
		e.issues.push(t), e.message = JSON.stringify(e.issues, a, 2);
	}), ro(n, "addIssues", (e) => (t) => {
		e.issues.push(...t), e.message = JSON.stringify(e.issues, a, 2);
	}), Object.defineProperty(n, "isEmpty", {
		configurable: !0,
		enumerable: !1,
		get() {
			return this.issues.length === 0;
		}
	}));
}, void 0, { Parent: Error }), io = /* @__PURE__ */ tt(K), ao = /* @__PURE__ */ nt(K), oo = /* @__PURE__ */ rt(K), so = /* @__PURE__ */ at(K), co = /* @__PURE__ */ dt(K), lo = /* @__PURE__ */ ft(K), uo = /* @__PURE__ */ pt(K), fo = /* @__PURE__ */ mt(K), po = /* @__PURE__ */ ht(K), mo = /* @__PURE__ */ gt(K), ho = /* @__PURE__ */ _t(K), go = /* @__PURE__ */ vt(K);
//#endregion
//#region ../../node_modules/.pnpm/zod@4.6.5/node_modules/zod/v4/classic/schemas.js
function _o() {
	A.localeError || j(ii());
}
function vo() {
	A.memoizer || j({ memoizer: ti() });
}
var q = /*@__PURE__*/ O("ZodType", (e, t) => (_o(), N.init(e, t), e.def = t, e.type = t.type, e), {
	check(...e) {
		let t = this.def;
		return this.clone(_(t, { checks: [...t.checks ?? [], ...e.map((e) => typeof e == "function" ? { _zod: {
			check: e,
			def: { check: "custom" },
			onattach: []
		} } : e)] }), { parent: !0 });
	},
	with(...e) {
		return this.check(...e);
	},
	clone(e, t) {
		return y(this, e, t);
	},
	brand() {
		return this;
	},
	register(e, t) {
		return e.add(this, t), this;
	},
	refine(e, t) {
		return this.check(ks(e, t));
	},
	superRefine(e, t) {
		return this.check(As(e, t));
	},
	overwrite(e) {
		return this.check(/* @__PURE__ */ R(e));
	},
	optional() {
		return ds(this);
	},
	exactOptional() {
		return ps(this);
	},
	nullable() {
		return hs(this);
	},
	nullish() {
		return ds(hs(this));
	},
	nonoptional(e) {
		return xs(this, e);
	},
	array() {
		return es(this);
	},
	or(e) {
		return rs([this, e]);
	},
	and(e) {
		return as(this, e);
	},
	transform(e) {
		return Ts(this, ls(e));
	},
	default(e) {
		return _s(this, e);
	},
	prefault(e) {
		return ys(this, e);
	},
	catch(e) {
		return Cs(this, e);
	},
	pipe(e) {
		return Ts(this, e);
	},
	readonly() {
		return Ds(this);
	},
	describe(e) {
		let t = this.clone();
		return L.add(t, { description: e }), t;
	},
	meta(...e) {
		if (e.length === 0) return L.get(this);
		let t = this.clone();
		return L.add(t, e[0]), t;
	},
	isOptional() {
		return this.safeParse(void 0).success;
	},
	isNullable() {
		return this.safeParse(null).success;
	},
	apply(e, ...t) {
		return t.length === 0 ? e(this) : e(this, ...t);
	},
	get "~standard"() {
		return Ae(this, "~standard", {
			...yn(this),
			jsonSchema: {
				input: xa(this, "input"),
				output: xa(this, "output")
			}
		});
	},
	set "~standard"(e) {
		T(this, "~standard", e);
	},
	parse: function e(t, n) {
		return io(this, t, n, { callee: e });
	},
	parseAsync: async function e(t, n) {
		return await ao(this, t, n, { callee: e });
	},
	safeParse(e, t) {
		return oo(this, e, t);
	},
	async safeParseAsync(e, t) {
		return so(this, e, t);
	},
	get spa() {
		return this?.safeParseAsync;
	},
	set spa(e) {
		T(this, "spa", e);
	},
	validate(e, t) {
		return ct(this, e, t);
	},
	validateAsync(e, t) {
		return ut(this, e, t);
	},
	encode: function e(t, n) {
		return co(this, t, n, { callee: e });
	},
	decode: function e(t, n) {
		return lo(this, t, n, { callee: e });
	},
	encodeAsync: async function e(t, n) {
		return await uo(this, t, n, { callee: e });
	},
	decodeAsync: async function e(t, n) {
		return await fo(this, t, n, { callee: e });
	},
	safeEncode(e, t) {
		return po(this, e, t);
	},
	safeDecode(e, t) {
		return mo(this, e, t);
	},
	async safeEncodeAsync(e, t) {
		return ho(this, e, t);
	},
	async safeDecodeAsync(e, t) {
		return go(this, e, t);
	},
	toJSONSchema(e) {
		return ba(this, {})(e);
	},
	get description() {
		return L.get(this)?.description;
	},
	get _def() {
		return this._zod.def;
	}
}), yo = /*@__PURE__*/ O("_ZodString", (e, t) => {
	bn.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Pa(e, t, n, r);
}, /*@__PURE__*/ je({
	format: (e) => G(e).format ?? null,
	minLength: (e) => G(e).minimum ?? null,
	maxLength: (e) => G(e).maximum ?? null
}, {
	regex(...e) {
		return this.check(/* @__PURE__ */ Yi(...e));
	},
	includes(...e) {
		return this.check(/* @__PURE__ */ Qi(...e));
	},
	startsWith(...e) {
		return this.check(/* @__PURE__ */ $i(...e));
	},
	endsWith(...e) {
		return this.check(/* @__PURE__ */ ea(...e));
	},
	min(...e) {
		return this.check(/* @__PURE__ */ qi(...e));
	},
	max(...e) {
		return this.check(/* @__PURE__ */ Ki(...e));
	},
	length(...e) {
		return this.check(/* @__PURE__ */ Ji(...e));
	},
	nonempty(...e) {
		return this.check(/* @__PURE__ */ qi(1, ...e));
	},
	lowercase(e) {
		return this.check(/* @__PURE__ */ Xi(e));
	},
	uppercase(e) {
		return this.check(/* @__PURE__ */ Zi(e));
	},
	trim() {
		return this.check(/* @__PURE__ */ na());
	},
	normalize(...e) {
		return this.check(/* @__PURE__ */ ta(...e));
	},
	toLowerCase() {
		return this.check(/* @__PURE__ */ ra());
	},
	toUpperCase() {
		return this.check(/* @__PURE__ */ ia());
	},
	slugify() {
		return this.check(/* @__PURE__ */ aa());
	}
})), bo = /*@__PURE__*/ O("ZodString", (e, t) => {
	bn.init(e, t), yo.init(e, t);
}, {
	email(e) {
		return this.check(/* @__PURE__ */ ui(Eo, e));
	},
	url(e) {
		return this.check(/* @__PURE__ */ gi(ko, e));
	},
	jwt(e) {
		return this.check(/* @__PURE__ */ ji(Wo, e));
	},
	emoji(e) {
		return this.check(/* @__PURE__ */ _i(Ao, e));
	},
	guid(e) {
		return this.check(/* @__PURE__ */ di(Do, e));
	},
	uuid(e) {
		return this.check(/* @__PURE__ */ fi(Oo, e));
	},
	uuidv4(e) {
		return this.check(/* @__PURE__ */ pi(Oo, e));
	},
	uuidv6(e) {
		return this.check(/* @__PURE__ */ mi(Oo, e));
	},
	uuidv7(e) {
		return this.check(/* @__PURE__ */ hi(Oo, e));
	},
	nanoid(e) {
		return this.check(/* @__PURE__ */ vi(jo, e));
	},
	cuid(e) {
		return this.check(/* @__PURE__ */ yi(Mo, e));
	},
	cuid2(e) {
		return this.check(/* @__PURE__ */ bi(No, e));
	},
	ulid(e) {
		return this.check(/* @__PURE__ */ xi(Po, e));
	},
	base64(e) {
		return this.check(/* @__PURE__ */ Oi(Vo, e));
	},
	base64url(e) {
		return this.check(/* @__PURE__ */ ki(Ho, e));
	},
	xid(e) {
		return this.check(/* @__PURE__ */ Si(Fo, e));
	},
	ksuid(e) {
		return this.check(/* @__PURE__ */ Ci(Io, e));
	},
	ipv4(e) {
		return this.check(/* @__PURE__ */ wi(Lo, e));
	},
	ipv6(e) {
		return this.check(/* @__PURE__ */ Ti(Ro, e));
	},
	cidrv4(e) {
		return this.check(/* @__PURE__ */ Ei(zo, e));
	},
	cidrv6(e) {
		return this.check(/* @__PURE__ */ Di(Bo, e));
	},
	e164(e) {
		return this.check(/* @__PURE__ */ Ai(Uo, e));
	},
	datetime(e) {
		return this.check(/* @__PURE__ */ Mi(So, e));
	},
	date(e) {
		return this.check(/* @__PURE__ */ Ni(Co, e));
	},
	time(e) {
		return this.check(/* @__PURE__ */ Pi(wo, e));
	},
	duration(e) {
		return this.check(/* @__PURE__ */ Fi(To, e));
	}
});
function xo(e) {
	return /* @__PURE__ */ li(bo, e);
}
var J = /*@__PURE__*/ O("ZodStringFormat", (e, t) => {
	P.init(e, t), yo.init(e, t);
}), So = /*@__PURE__*/ O("ZodISODateTime", (e, t) => {
	zn.init(e, t), J.init(e, t);
}), Co = /*@__PURE__*/ O("ZodISODate", (e, t) => {
	Bn.init(e, t), J.init(e, t);
}), wo = /*@__PURE__*/ O("ZodISOTime", (e, t) => {
	Vn.init(e, t), J.init(e, t);
}), To = /*@__PURE__*/ O("ZodISODuration", (e, t) => {
	Hn.init(e, t), J.init(e, t);
}), Eo = /*@__PURE__*/ O("ZodEmail", (e, t) => {
	Cn.init(e, t), J.init(e, t);
}), Do = /*@__PURE__*/ O("ZodGUID", (e, t) => {
	xn.init(e, t), J.init(e, t);
}), Oo = /*@__PURE__*/ O("ZodUUID", (e, t) => {
	Sn.init(e, t), J.init(e, t);
}), ko = /*@__PURE__*/ O("ZodURL", (e, t) => {
	jn.init(e, t), J.init(e, t);
}), Ao = /*@__PURE__*/ O("ZodEmoji", (e, t) => {
	Mn.init(e, t), J.init(e, t);
}), jo = /*@__PURE__*/ O("ZodNanoID", (e, t) => {
	Nn.init(e, t), J.init(e, t);
}), Mo = /*@__PURE__*/ O("ZodCUID", (e, t) => {
	Pn.init(e, t), J.init(e, t);
}), No = /*@__PURE__*/ O("ZodCUID2", (e, t) => {
	Fn.init(e, t), J.init(e, t);
}), Po = /*@__PURE__*/ O("ZodULID", (e, t) => {
	In.init(e, t), J.init(e, t);
}), Fo = /*@__PURE__*/ O("ZodXID", (e, t) => {
	Ln.init(e, t), J.init(e, t);
}), Io = /*@__PURE__*/ O("ZodKSUID", (e, t) => {
	Rn.init(e, t), J.init(e, t);
}), Lo = /*@__PURE__*/ O("ZodIPv4", (e, t) => {
	Un.init(e, t), J.init(e, t);
}), Ro = /*@__PURE__*/ O("ZodIPv6", (e, t) => {
	Kn.init(e, t), J.init(e, t);
}), zo = /*@__PURE__*/ O("ZodCIDRv4", (e, t) => {
	qn.init(e, t), J.init(e, t);
}), Bo = /*@__PURE__*/ O("ZodCIDRv6", (e, t) => {
	Yn.init(e, t), J.init(e, t);
}), Vo = /*@__PURE__*/ O("ZodBase64", (e, t) => {
	Qn.init(e, t), J.init(e, t);
}), Ho = /*@__PURE__*/ O("ZodBase64URL", (e, t) => {
	tr.init(e, t), J.init(e, t);
}), Uo = /*@__PURE__*/ O("ZodE164", (e, t) => {
	nr.init(e, t), J.init(e, t);
}), Wo = /*@__PURE__*/ O("ZodJWT", (e, t) => {
	ir.init(e, t), J.init(e, t);
}), Go = /*@__PURE__*/ O("ZodNumber", (e, t) => {
	ar.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Fa(e, t, n, r), e.isFinite = !0;
}, /*@__PURE__*/ je({
	minValue: (e) => {
		let { minimum: t, exclusiveMinimum: n } = G(e);
		return Math.max(t ?? -Infinity, n ?? -Infinity);
	},
	maxValue: (e) => {
		let { maximum: t, exclusiveMaximum: n } = G(e);
		return Math.min(t ?? Infinity, n ?? Infinity);
	},
	isInt: (e) => {
		let { isInt: t, multipleOf: n } = G(e);
		return !!t || !!n?.some(Number.isSafeInteger);
	},
	format: (e) => G(e).format ?? null
}, {
	gt(e, t) {
		return this.check(/* @__PURE__ */ Ui(e, t));
	},
	gte(e, t) {
		return this.check(/* @__PURE__ */ Wi(e, t));
	},
	min(e, t) {
		return this.check(/* @__PURE__ */ Wi(e, t));
	},
	lt(e, t) {
		return this.check(/* @__PURE__ */ Vi(e, t));
	},
	lte(e, t) {
		return this.check(/* @__PURE__ */ Hi(e, t));
	},
	max(e, t) {
		return this.check(/* @__PURE__ */ Hi(e, t));
	},
	int(e) {
		return this.check(qo(e));
	},
	safe(e) {
		return this.check(qo(e));
	},
	positive(e) {
		return this.check(/* @__PURE__ */ Ui(0, e));
	},
	nonnegative(e) {
		return this.check(/* @__PURE__ */ Wi(0, e));
	},
	negative(e) {
		return this.check(/* @__PURE__ */ Vi(0, e));
	},
	nonpositive(e) {
		return this.check(/* @__PURE__ */ Hi(0, e));
	},
	multipleOf(e, t) {
		return this.check(/* @__PURE__ */ Gi(e, t));
	},
	step(e, t) {
		return this.check(/* @__PURE__ */ Gi(e, t));
	},
	finite() {
		return this;
	}
}));
function Y(e) {
	return /* @__PURE__ */ Ii(Go, e);
}
var Ko = /*@__PURE__*/ O("ZodNumberFormat", (e, t) => {
	or.init(e, t), Go.init(e, t);
});
function qo(e) {
	return /* @__PURE__ */ Li(Ko, e);
}
var Jo = /*@__PURE__*/ O("ZodBoolean", (e, t) => {
	sr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ia(e, t, n, r);
});
function X(e) {
	return /* @__PURE__ */ Ri(Jo, e);
}
var Yo = /*@__PURE__*/ O("ZodUnknown", (e, t) => {
	cr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (e, t, n) => void 0;
});
function Xo() {
	return /* @__PURE__ */ zi(Yo);
}
var Zo = /*@__PURE__*/ O("ZodNever", (e, t) => {
	lr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => La(e, t, n, r);
});
function Qo(e) {
	return /* @__PURE__ */ Bi(Zo, e);
}
var $o = /*@__PURE__*/ O("ZodArray", (e, t) => {
	vo(), dr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Va(e, t, n, r), e.element = t.element;
}, {
	min(e, t) {
		return this.check(/* @__PURE__ */ qi(e, t));
	},
	nonempty(e) {
		return this.check(/* @__PURE__ */ qi(1, e));
	},
	max(e, t) {
		return this.check(/* @__PURE__ */ Ki(e, t));
	},
	length(e, t) {
		return this.check(/* @__PURE__ */ Ji(e, t));
	},
	unwrap() {
		return this.element;
	}
});
function es(e, t) {
	return /* @__PURE__ */ oa($o, e, t);
}
var ts = /*@__PURE__*/ O("ZodObject", (e, t) => {
	vo(), _r.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ua(e, t, n, r), Ie(e, "shape", (e) => e._zod.def.shape, !1);
}, {
	keyof() {
		return ss(Object.keys(this._zod.def.shape));
	},
	catchall(e) {
		return this.clone(_(this._zod.def, { catchall: e }));
	},
	passthrough() {
		return this.clone(_(this._zod.def, { catchall: Xo() }));
	},
	loose() {
		return this.clone(_(this._zod.def, { catchall: Xo() }));
	},
	strict() {
		return this.clone(_(this._zod.def, { catchall: Qo() }));
	},
	strip() {
		return this.clone(_(this._zod.def, { catchall: void 0 }));
	},
	extend(e) {
		return ge(this, e);
	},
	safeExtend(e) {
		return ve(this, e);
	},
	merge(e) {
		return ye(this, e);
	},
	pick(e) {
		return pe(this, e);
	},
	omit(e) {
		return he(this, e);
	},
	partial(...e) {
		return be(us, this, e[0]);
	},
	exactPartial(...e) {
		return be(fs, this, e[0], "exactPartial");
	},
	required(...e) {
		return xe(bs, this, e[0]);
	}
});
function Z(e, t) {
	return new ts({
		type: "object",
		shape: e ?? {},
		...b(t)
	});
}
var ns = /*@__PURE__*/ O("ZodUnion", (e, t) => {
	yr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Wa(e, t, n, r), e.options = t.options;
});
function rs(e, t) {
	return new ns({
		type: "union",
		options: e,
		...b(t)
	});
}
var is = /*@__PURE__*/ O("ZodIntersection", (e, t) => {
	br.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ga(e, t, n, r);
});
function as(e, t) {
	return new is({
		type: "intersection",
		left: e,
		right: t
	});
}
var os = /*@__PURE__*/ O("ZodEnum", (e, t) => {
	Cr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ra(e, t, n, r), e.enum = t.entries, e.options = [...e._zod.values];
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new os({
			...t,
			checks: [],
			...b(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new os({
			...t,
			checks: [],
			...b(r),
			entries: i
		});
	};
});
function ss(e, t) {
	return new os({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...b(t)
	});
}
var cs = /*@__PURE__*/ O("ZodTransform", (e, t) => {
	vo(), wr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ba(e, t, n, r), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new Ue(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(w(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", "input" in t || (t.input = n.value), t.inst ??= e, n.issues.push(w(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n)) : (n.value = i, n);
	};
});
function ls(e) {
	return new cs({
		type: "transform",
		transform: e
	});
}
var us = /*@__PURE__*/ O("ZodOptional", (e, t) => {
	Er.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => to(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function ds(e) {
	return new us({
		type: "optional",
		innerType: e
	});
}
var fs = /*@__PURE__*/ O("ZodExactOptional", (e, t) => {
	Dr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => to(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function ps(e) {
	return new fs({
		type: "optional",
		innerType: e
	});
}
var ms = /*@__PURE__*/ O("ZodNullable", (e, t) => {
	Or.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ka(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function hs(e) {
	return new ms({
		type: "nullable",
		innerType: e
	});
}
var gs = /*@__PURE__*/ O("ZodDefault", (e, t) => {
	kr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Xa(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function _s(e, t) {
	return new gs({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : oe(t);
		}
	});
}
var vs = /*@__PURE__*/ O("ZodPrefault", (e, t) => {
	jr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Za(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function ys(e, t) {
	return new vs({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : oe(t);
		}
	});
}
var bs = /*@__PURE__*/ O("ZodNonOptional", (e, t) => {
	Mr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => qa(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function xs(e, t) {
	return new bs({
		type: "nonoptional",
		innerType: e,
		...b(t)
	});
}
var Ss = /*@__PURE__*/ O("ZodCatch", (e, t) => {
	Fr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => Qa(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Cs(e, t) {
	return new Ss({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : Re(t)
	});
}
var ws = /*@__PURE__*/ O("ZodPipe", (e, t) => {
	Ir.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => $a(e, t, n, r), e.in = t.in, e.out = t.out;
});
function Ts(e, t) {
	return new ws({
		type: "pipe",
		in: e,
		out: t
	});
}
var Es = /*@__PURE__*/ O("ZodReadonly", (e, t) => {
	Rr.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => eo(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Ds(e) {
	return new Es({
		type: "readonly",
		innerType: e
	});
}
var Os = /*@__PURE__*/ O("ZodCustom", (e, t) => {
	Br.init(e, t), q.init(e, t), e._zod.processJSONSchema = (t, n, r) => za(e, t, n, r);
});
function ks(e, t = {}) {
	return /* @__PURE__ */ sa(Os, e, t);
}
function As(e, t) {
	return /* @__PURE__ */ ca(e, t);
}
//#endregion
//#region src/lib/input-schemas.ts
var Q = {
	[e.updateMaxLevels]: Z({ maxLevels: Y().min(n.maxLevels.min).max(n.maxLevels.max).describe("The number of floors or levels to set in the building model.") }),
	[e.updateCommercialHeight]: Z({ commercialHeight: Y().min(n.commercialHeight.min).max(n.commercialHeight.max).describe("The height in metres of the commercial ground floor. Set to 0 to disable commercial height.") }),
	[e.updateCorridorWidth]: Z({ corridorWidth: Y().min(n.corridorWidth.min).max(n.corridorWidth.max).describe("The width in metres of the building corridor") }),
	[e.updateUnitHeight]: Z({ unitHeight: Y().min(n.unitHeight.min).max(n.unitHeight.max).describe("The height in metres of each residential unit / floor") }),
	[e.updateWingLengthRange]: Z({
		minWingLength: Y().min(n.wingLength.min).max(n.wingLength.max).describe("The minimum length in metres of a building wing. Should be less than or equal to the maxWingLength."),
		maxWingLength: Y().min(n.wingLength.min).max(n.wingLength.max).describe("The maximum length in metres of a building wing")
	}),
	[e.updateWingMinSetback]: Z({ wingMinSetback: Y().min(n.wingMinSetback.min).max(n.wingMinSetback.max).describe("The minimum setback in metres between building wings and the site boundary") }),
	[e.updateWingSetbackFactor]: Z({ wingSetbackFactor: Y().min(n.wingSetbackFactor.min).max(n.wingSetbackFactor.max).describe("A factor between 0 and 1 controlling how much setback is applied between building wings") }),
	[e.updateMaxGsi]: Z({
		maxGsiOn: X().describe("Whether the max GSI cap is active. Set false to remove the cap."),
		maxGsi: Y().min(n.maxGsi.min).max(n.maxGsi.max).describe("Maximum fraction (0–1.0) of the plot area that buildings may cover. Only applied when maxGsiOn is true.")
	}),
	[e.updateMaxAncillaryGsi]: Z({
		maxAncillaryGsiOn: X().describe("Whether a custom GSI II cap is active. Set false to fall back to the legal derivation from the max GSI."),
		maxAncillaryGsi: Y().min(n.maxAncillaryGsi.min).max(n.maxAncillaryGsi.max).describe("Maximum fraction (0–1.0) of the plot area covered by buildings plus ancillary surfaces such as parking (GSI II, German GRZ II). Only applied when maxAncillaryGsiOn is true.")
	}),
	[e.updateTargetFar]: Z({
		targetFarOn: X().describe("Whether the FAR cap is active. Set false to remove the cap."),
		targetFar: Y().min(n.targetFar.min).max(n.targetFar.max).describe("Target floor area ratio the massing should pack levels to reach. Only applied when targetFarOn is true.")
	}),
	[e.updateParkingMultiplier]: Z({ parkingMultiplier: Y().min(n.parkingMultiplier.min).max(n.parkingMultiplier.max).describe("Multiplier applied to the parking demand from all parking factors, reflecting site context such as public transport access, centrality, car-sharing or a mobility concept. Required parking spots = sum of parking factor spaces × this multiplier.") }),
	[e.updateBalconiesAffectMassing]: Z({ balconiesAffectMassing: X().describe("Whether massing reserves the balcony-inflated setback instead of the base wing setback.") }),
	[e.updateUnitMixOn]: Z({ unitMixOn: X().describe("Whether the unit mix configuration is active. Set to true to enable, false to disable.") }),
	[e.updateLoadType]: Z({ loadType: ss(["double", "single"]).describe("The building access type. Use double for a central corridor, single for a gallery.") }),
	[e.updateBuildingMaxLevels]: Z({
		buildingId: xo().describe("The ID of the building to update."),
		maxLevels: Y().min(n.maxLevels.min).max(n.maxLevels.max).describe("The maximum number of floors or levels to set for the specified building.")
	})
}, js = /* @__PURE__ */ function(e) {
	return e.getFacadeArea = "getFacadeArea", e;
}({}), Ms = "vercel.ai.error", Ns = Symbol.for(Ms), Ps, Fs, Is = class e extends (Fs = Error, Ps = Ns, Fs) {
	constructor({ name: e, message: t, cause: n }) {
		super(t), this[Ps] = !0, this.name = e, this.cause = n;
	}
	static isInstance(t) {
		return e.hasMarker(t, Ms);
	}
	static hasMarker(e, t) {
		let n = Symbol.for(t);
		return typeof e == "object" && !!e && n in e && typeof e[n] == "boolean" && e[n] === !0;
	}
}, Ls = "AI_InvalidArgumentError", Rs = `vercel.ai.error.${Ls}`, zs = Symbol.for(Rs), Bs, Vs, Hs = class extends (Vs = Is, Bs = zs, Vs) {
	constructor({ message: e, cause: t, argument: n }) {
		super({
			name: Ls,
			message: e,
			cause: t
		}), this[Bs] = !0, this.argument = n;
	}
	static isInstance(e) {
		return Is.hasMarker(e, Rs);
	}
};
new TextDecoder();
var { btoa: Us, atob: Ws } = globalThis;
(({ prefix: e, size: t = 16, alphabet: n = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", separator: r = "-" } = {}) => {
	let i = () => {
		let e = n.length, r = Array(t);
		for (let i = 0; i < t; i++) r[i] = n[Math.random() * e | 0];
		return r.join("");
	};
	if (e == null) return i;
	if (n.includes(r)) throw new Hs({
		argument: "separator",
		message: `The separator "${r}" must not be part of the alphabet "${n}".`
	});
	return () => `${e}${r}${i()}`;
})();
function $(e) {
	return e;
}
new TextDecoder();
var Gs = {
	[e.updateMaxLevels]: $({
		description: "Sets the number of floors or levels for ALL buildings across the entire site. Only call this when the user explicitly targets every building — e.g. 'Set all buildings to 5 floors' or 'Change the floor count across the whole site.' NEVER call this if the system context indicates the chat is attached to a specific building — use updateBuildingMaxLevels instead.",
		inputSchema: Q[e.updateMaxLevels],
		strict: !0
	}),
	[e.updateCommercialHeight]: $({
		description: "Sets the height in metres of the commercial ground floor. Call this when the user wants to change or set the commercial floor height, for example when they say 'Set the commercial height to 4 metres' or 'The ground floor should be 5m tall.' Use 0 to disable the commercial height.",
		inputSchema: Q[e.updateCommercialHeight],
		strict: !0
	}),
	[e.updateCorridorWidth]: $({
		description: "Sets the width in metres of the building corridor. Call this when the user wants to change the corridor width, for example when they say 'Make the corridor 2 metres wide' or 'Set the hallway width to 3m.'",
		inputSchema: Q[e.updateCorridorWidth],
		strict: !0
	}),
	[e.updateUnitHeight]: $({
		description: "Sets the floor-to-floor height in metres for residential units. Call this when the user wants to change the storey height, for example when they say 'Set the unit height to 3.2 metres' or 'Each floor should be 2.8m tall.'",
		inputSchema: Q[e.updateUnitHeight],
		strict: !0
	}),
	[e.updateWingLengthRange]: $({
		description: "Sets the minimum and maximum length in metres of building wings. Call this when the user wants to constrain wing lengths, for example when they say 'Wings should be between 15 and 60 metres' or 'Set the max wing length to 50m.'",
		inputSchema: Q[e.updateWingLengthRange],
		strict: !0
	}),
	[e.updateWingMinSetback]: $({
		description: "Sets the minimum padding in metres between building wings and the site boundary. Call this when the user wants to change the wing setback, for example when they say 'Set the wing padding to 5 metres' or 'Keep wings at least 8m from the boundary.'",
		inputSchema: Q[e.updateWingMinSetback],
		strict: !0
	}),
	[e.updateWingSetbackFactor]: $({
		description: "Sets the padding factor (0–1) controlling spacing between building wings. Call this when the user wants to adjust how spread out wings are, for example when they say 'Set the wing padding factor to 0.7' or 'Increase the spacing between wings.'",
		inputSchema: Q[e.updateWingSetbackFactor],
		strict: !0
	}),
	[e.updateMaxGsi]: $({
		description: "Sets the max GSI (Ground Space Index; also called site/lot coverage, BCR, German GRZ): the maximum fraction (0–1.0) of the plot area covered by buildings. Call when the user wants to cap site coverage — e.g. 'Limit building coverage to 60%' (pass maxGsi 0.6, maxGsiOn true). To remove the limit (e.g. 'No land coverage limit'), set maxGsiOn false.",
		inputSchema: Q[e.updateMaxGsi],
		strict: !0
	}),
	[e.updateMaxAncillaryGsi]: $({
		description: "Sets the maximum fraction (0–1.0) of the plot area covered by buildings plus ancillary surfaces such as parking (GSI II, German GRZ II). Call when the user wants a custom GSI II cap, e.g. 'Limit coverage including parking to 60%' (pass maxAncillaryGsi 0.6, maxAncillaryGsiOn true). To fall back to the legal derivation from the max GSI, set maxAncillaryGsiOn false.",
		inputSchema: Q[e.updateMaxAncillaryGsi],
		strict: !0
	}),
	[e.updateParkingMultiplier]: $({
		description: "Sets the parking multiplier (range 0–2) that scales the parking demand from all parking factors (by apartment type, apartment area range and total floor area). Required parking spots = sum of parking factor spaces × this multiplier. Call when the user wants to scale parking provision for the site context, e.g. 'Set the parking multiplier to 0.8' or 'Reduce parking by 20% for good public transport.'",
		inputSchema: Q[e.updateParkingMultiplier],
		strict: !0
	}),
	[e.updateUnitMixOn]: $({
		description: "Enables or disables the unit mix configuration. Call this when the user wants to toggle the unit mix, for example when they say 'Turn on unit mix' or 'Disable the unit mix.'",
		inputSchema: Q[e.updateUnitMixOn],
		strict: !0
	}),
	[e.updateBuildingMaxLevels]: $({
		description: "Sets the maximum number of floors or levels for a specific building. If the system context indicates this chat is attached to a building, ALWAYS call this instead of updateMaxLevels — even if the user just says 'set the floors to 10' without mentioning a specific building. Only fall back to updateMaxLevels if the user explicitly asks to change floors for all buildings across the whole site.",
		inputSchema: Q[e.updateBuildingMaxLevels],
		strict: !0
	})
}, Ks = { [js.getFacadeArea]: $({
	description: "Returns the total facade area of the project. Call this when the user wants to know the total area of the building's facades, for example when they say 'What is the total facade area?' or 'How much facade area does the building have?'",
	inputSchema: Z({})
}) }, qs = {
	...Gs,
	...Ks
};
//#endregion
export { e as ActionType, js as QueryType, n as inputConstraints, Q as inputSchemas, qs as tools };
